function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3300 2000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#9BC1F9"
    },
    d: "M233.022,1772.145l2862.603,3.627c189.437-157.256,9.643-645.896-148.587-741.821 c-170.319-103.257,10.805-578.977-251.565-694.887c-171.307-75.679-575.768,91.923-697.305-65.034 c-217.329-280.668-511.194-151.549-773.91-48.14c-323.128,127.189-419.581,9-709.217,188.943 c-438.383,272.356-7.752,746.065-207.52,886.256C14.59,1506.657,226.117,1768.36,233.022,1772.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1324.275,598.731c-4.457-19.519-21.816-34.081-42.567-34.081 c-3.81,0-7.504,0.493-11.027,1.415c-10.242-22.038-32.469-37.308-58.243-37.308c-6.664,0-13.09,1.021-19.134,2.915 c-13.875-23.12-39.084-38.578-67.883-38.578c-34.263,0-63.446,21.881-74.504,52.514c-7.827-4.391-16.838-6.902-26.436-6.902 c-30.033,0-54.379,24.497-54.379,54.717c0,1.792,0.092,3.561,0.259,5.309H1324.275z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2E35"
    },
    d: "M2964.656,1427.703c-0.318-2.169-3.545-3.854-4.93-1.931c-1.379,1.917-1.461,0.622-2.539,4.769 c-3.096,11.902-8.341,23.417-14.834,33.48c-12.441,19.281-25.848,29.009-41.232,38.646c5.041-15.133,7.717-31.286,6.401-47.58 c-0.479-5.938-1.312-12.096-4.519-17.545c-0.895-1.521-3.619-1.209-3.701,0.486c-0.408,8.408,2.369,14.748,1.365,29.796 c-2.398,35.907-23.995,73.993-45.999,100.663c-0.438-45.15-4.075-96.463-17.984-142.003c-2.281-7.47-5.354-14.574-8.289-21.872 c-0.69-1.717-3.076-0.979-2.573,0.726c0.716,2.428,8.464,33.767,8.963,35.926c8.016,34.683,11.69,73.104,12.67,108.142 c-22.506-26.045-39.086-56.506-48.883-88.314c-2.896-9.403-4.506-19.111-8.106-28.34c-0.495-1.271-2.639-1.407-2.739,0 c-0.986,13.826,7.055,38.284,12.387,51.573c10.807,26.931,25.892,51.07,45.184,72.635c0.75,0.838-2.338,211.566-1.285,214.234 c1.775,4.5,10.082,7.659,10.384-0.325c0.124-3.251,0.384-131.382,0.323-190.734c2.422-1.407,3.795-3.91,9.589-11.295 c13.409-17.093,26.161-38.359,34.004-58.416c6.067-0.343,47.7-21.531,63.962-69.781c0.469-1.391,2.55-7.922,2.786-9.379 C2965.263,1430.016,2964.837,1428.935,2964.656,1427.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M2820.228,1358.819c0.503-6.568,0.764-13.285,0.764-20.119c0-76.221-32.35-138.009-72.256-138.009 c-39.905,0-72.256,61.788-72.256,138.009c0,6.834,0.262,13.551,0.765,20.119H2820.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2902.002,1324.901c0.502-9.263,0.764-18.736,0.764-28.374c0-107.49-32.35-194.629-72.256-194.629 c-39.905,0-72.256,87.139-72.256,194.629c0,9.638,0.262,19.111,0.764,28.374H2902.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2875.546,1444.166c-0.502-6.568-0.764-13.285-0.764-20.119c0-76.22,32.351-138.009,72.256-138.009 c39.906,0,72.256,61.789,72.256,138.009c0,6.834-0.261,13.551-0.764,20.119H2875.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M2759.906,1444.166c-0.637-9.262-0.969-18.735-0.969-28.373 c0-107.49,41.011-194.629,91.599-194.629c50.589,0,91.599,87.139,91.599,194.629c0,9.638-0.332,19.111-0.969,28.373H2759.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2830.236,1221.164c-25.283,0-47.87,27.645-62.777,70.999c-7.591-3.981-15.656-6.124-24.017-6.124 c-44.89,0-81.278,61.788-81.278,138.008c0,6.834,0.293,13.552,0.858,20.119h247.633c0.565-9.262,0.859-18.735,0.859-28.373 C2911.515,1308.303,2875.125,1221.164,2830.236,1221.164z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M2015.795,611.399c3.321-14.544,16.256-25.395,31.718-25.395 c2.839,0,5.592,0.368,8.217,1.055c7.631-16.421,24.192-27.799,43.397-27.799c4.966,0,9.754,0.76,14.258,2.172 c10.338-17.227,29.122-28.745,50.58-28.745c25.53,0,47.275,16.304,55.515,39.128c5.832-3.272,12.546-5.143,19.697-5.143 c22.378,0,40.519,18.254,40.519,40.771c0,1.335-0.068,2.654-0.192,3.956H2015.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1823.514,354.558c-3.027-13.258-14.818-23.149-28.913-23.149 c-2.588,0-5.097,0.335-7.49,0.961c-6.956-14.969-22.054-25.341-39.561-25.341c-4.526,0-8.892,0.693-12.997,1.98 c-9.424-15.703-26.547-26.204-46.108-26.204c-23.272,0-43.095,14.863-50.606,35.669c-5.316-2.982-11.437-4.688-17.956-4.688 c-20.4,0-36.937,16.64-36.937,37.167c0,1.217,0.062,2.419,0.176,3.606H1823.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 297.442,
    y: 1629.46,
    style: {
      fill: "#355389"
    },
    width: 6.466,
    height: 75.897
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C8F7C"
    },
    points: "301.81,1494.144 280.466,1647.341 323.153,1647.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "281.82,1637.621 320.117,1625.548 319.538,1621.393 282.452,1633.084  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "288.563,1589.224 313.941,1581.223 313.363,1577.068 289.195,1584.687  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.272,
    y: 1617.27,
    style: {
      fill: "#355389"
    },
    width: 9.75,
    height: 108.07
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C8F7C"
    },
    points: "228.147,1407.619 196.323,1664.813 259.972,1664.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "207.865,1571.53 253.244,1610.443 251.499,1596.343 209.275,1560.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "214.841,1515.154 242.629,1524.655 241.323,1514.097 216.041,1505.453  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "1334.346,696.556 1624.504,584.772 1905.666,696.556 1644.748,707.358 1340.531,702.297  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "2730.594,661.692 2608.008,430.133 2476.424,430.133 2356.834,661.692  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2353.838,
    y: 681.491,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5084.4316 2453.3271)",
    style: {
      fill: "#F8C48B"
    },
    width: 376.756,
    height: 1090.345
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2430.313,
    y: 1102.672,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5173.2783 2231.7725)",
    style: {
      fill: "#FCF5EB"
    },
    width: 312.651,
    height: 26.429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2415.131,
    y: 1604.826,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5145.7246 3376.6621)",
    style: {
      fill: "#9B4234"
    },
    width: 315.463,
    height: 167.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2430.313,
    y: 1578.396,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5173.2783 3183.2227)",
    style: {
      fill: "#FCF5EB"
    },
    width: 312.651,
    height: 26.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2353.838,
    y: 681.491,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4830.2617 2453.3271)",
    style: {
      opacity: 0.5,
      fill: "#F8C48B"
    },
    width: 122.586,
    height: 1090.345
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2648.55,1301.088c0,12.957,10.504,23.462,23.461,23.462c12.958,0,23.462-10.505,23.462-23.462 s-10.504-23.461-23.462-23.461C2659.054,1277.627,2648.55,1288.131,2648.55,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2632.748,1194.806c0-17.499,17.57-31.685,39.244-31.685c21.673,0,39.243,14.186,39.243,31.685 c0,0.045-0.002,0.089-0.002,0.134h0.002v97.994h-78.487v-97.994h0.002C2632.75,1194.895,2632.748,1194.851,2632.748,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2638.875,1196.779c0-15.341,14.827-27.775,33.117-27.775c18.289,0,33.116,12.435,33.116,27.775 c0,0.039-0.001,0.077-0.002,0.117h0.002v90.021h-66.233v-90.021h0.002C2638.877,1196.856,2638.875,1196.818,2638.875,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2670.61,
    y: 1163.924,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5344.1494 2455.9209)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2623.311,
    y: 1292.934,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5343.3223 2594.0215)",
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2670.611,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3883.5776 -1460.5728)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2670.611,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3921.396 -1422.7544)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2638.875,1211.197v-14.301h0.002c0-0.039-0.002-0.078-0.002-0.117 c0-11.78,8.748-21.841,21.09-25.879l45.144,69.507v46.51h-22.576C2670.094,1265.289,2652.712,1235.1,2638.875,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2519.215,1301.088c0,12.957,10.504,23.462,23.461,23.462c12.958,0,23.462-10.505,23.462-23.462 s-10.504-23.461-23.462-23.461C2529.719,1277.627,2519.215,1288.131,2519.215,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2503.414,1194.806c0-17.499,17.57-31.685,39.243-31.685c21.674,0,39.243,14.186,39.243,31.685 c0,0.045-0.001,0.089-0.002,0.134h0.002v97.994h-78.486v-97.994h0.002C2503.416,1194.895,2503.414,1194.851,2503.414,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2509.541,1196.779c0-15.341,14.826-27.775,33.116-27.775s33.117,12.435,33.117,27.775 c0,0.039-0.002,0.077-0.002,0.117h0.002v90.021h-66.233v-90.021h0.001C2509.542,1196.856,2509.541,1196.818,2509.541,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.275,
    y: 1163.924,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5085.4805 2455.9209)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2493.976,
    y: 1292.934,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5084.6523 2594.0215)",
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.276,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3754.2427 -1331.2378)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.276,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3792.061 -1293.4194)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2509.541,1211.197v-14.301h0.001c0-0.039-0.001-0.078-0.001-0.117 c0-11.78,8.748-21.841,21.09-25.879l45.144,69.507v46.51h-22.576C2540.76,1265.289,2523.378,1235.1,2509.541,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2648.55,1541.2c0,12.957,10.504,23.461,23.461,23.461c12.958,0,23.462-10.504,23.462-23.461 c0-12.958-10.504-23.462-23.462-23.462C2659.054,1517.738,2648.55,1528.242,2648.55,1541.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2632.748,1434.917c0-17.498,17.57-31.684,39.244-31.684c21.673,0,39.243,14.186,39.243,31.684 c0,0.045-0.002,0.09-0.002,0.134h0.002v97.994h-78.487v-97.994h0.002C2632.75,1435.007,2632.748,1434.962,2632.748,1434.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2638.875,1436.891c0-15.34,14.827-27.775,33.117-27.775c18.289,0,33.116,12.436,33.116,27.775 c0,0.039-0.001,0.078-0.002,0.117h0.002v90.021h-66.233v-90.021h0.002C2638.877,1436.969,2638.875,1436.93,2638.875,1436.891z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2670.61,
    y: 1404.035,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5344.1494 2936.1445)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2623.311,
    y: 1533.045,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5343.3223 3074.2451)",
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2670.611,
    y: 1415.132,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4123.689 -1220.4614)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2670.611,
    y: 1452.951,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4161.5073 -1182.6429)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2638.875,1451.31v-14.302h0.002c0-0.039-0.002-0.078-0.002-0.117 c0-11.78,8.748-21.84,21.09-25.878l45.144,69.507v46.51h-22.576C2670.094,1505.4,2652.712,1475.212,2638.875,1451.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2519.215,1541.2c0,12.957,10.504,23.461,23.461,23.461c12.958,0,23.462-10.504,23.462-23.461 c0-12.958-10.504-23.462-23.462-23.462C2529.719,1517.738,2519.215,1528.242,2519.215,1541.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2503.414,1434.917c0-17.498,17.57-31.684,39.243-31.684c21.674,0,39.243,14.186,39.243,31.684 c0,0.045-0.001,0.09-0.002,0.134h0.002v97.994h-78.486v-97.994h0.002C2503.416,1435.007,2503.414,1434.962,2503.414,1434.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2509.541,1436.891c0-15.34,14.826-27.775,33.116-27.775s33.117,12.436,33.117,27.775 c0,0.039-0.002,0.078-0.002,0.117h0.002v90.021h-66.233v-90.021h0.001C2509.542,1436.969,2509.541,1436.93,2509.541,1436.891z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.275,
    y: 1404.035,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5085.4805 2936.1445)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 128.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2493.976,
    y: 1533.045,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5084.6523 3074.2451)",
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.276,
    y: 1415.132,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3994.354 -1091.1265)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.276,
    y: 1452.951,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4032.1724 -1053.3081)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2509.541,1451.31v-14.302h0.001c0-0.039-0.001-0.078-0.001-0.117 c0-11.78,8.748-21.84,21.09-25.878l45.144,69.507v46.51h-22.576C2540.76,1505.4,2523.378,1475.212,2509.541,1451.31z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF5EB"
    },
    points: "2499.783,661.692 2505.529,661.692 2755.336,661.692 2755.336,682.916 2505.529,682.916  2499.783,682.916 2329.096,682.916 2329.096,661.692  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2576.237,955.878c0,16.475,13.354,29.83,29.83,29.83c16.474,0,29.83-13.355,29.83-29.83 s-13.356-29.83-29.83-29.83C2589.592,926.048,2576.237,939.404,2576.237,955.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2556.146,820.745c0-22.249,22.34-40.285,49.896-40.285s49.896,18.036,49.896,40.285 c0,0.057-0.003,0.113-0.003,0.17h0.003V945.51h-99.793V820.915h0.003C2556.149,820.858,2556.146,820.802,2556.146,820.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2563.937,823.254c0-19.504,18.852-35.315,42.106-35.315s42.106,15.811,42.106,35.315 c0,0.05-0.002,0.099-0.002,0.149h0.002V937.86h-84.213V823.403h0.002C2563.938,823.354,2563.937,823.304,2563.937,823.254z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2604.286,
    y: 781.48,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5212.2959 1725.7998)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.724,
    height: 162.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2544.146,
    y: 945.51,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5211.2441 1901.3882)",
    style: {
      fill: "#F2E3D1"
    },
    width: 122.951,
    height: 10.369
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2604.286,
    y: 795.59,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3448.1228 -1764.1741)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.724,
    height: 92.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2604.286,
    y: 843.674,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3496.2068 -1716.0901)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.724,
    height: 92.77
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2564.101,841.732v-18.173h0.002c0-0.049-0.002-0.099-0.002-0.148 c0-14.969,11.116-27.752,26.799-32.884l57.364,88.323v59.1h-28.688C2603.771,910.466,2581.684,872.105,2564.101,841.732z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#F8C48B"
    },
    d: "M2476.424,661.692c-2.812,0.118,67.29-231.559,67.29-231.559h-67.29l-119.59,231.559 H2476.424z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF5EB"
    },
    points: "2526.206,414.832 2528.373,414.832 2622.628,414.832 2622.628,436.057 2528.373,436.057  2526.206,436.057 2461.804,436.057 2461.804,414.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "2542.2,150.833 2542.216,150.659 2614.756,414.832 2573.394,414.832 2540.093,414.904  2540.092,414.95 2469.676,414.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "515.041,661.692 637.627,430.133 769.211,430.133 888.801,661.692  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.041,
    y: 681.491,
    style: {
      fill: "#F8C48B"
    },
    width: 376.757,
    height: 1090.345
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.67,
    y: 1102.672,
    style: {
      fill: "#FCF5EB"
    },
    width: 312.652,
    height: 26.429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.041,
    y: 1604.826,
    style: {
      fill: "#9B4234"
    },
    width: 315.463,
    height: 167.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.67,
    y: 1578.396,
    style: {
      fill: "#FCF5EB"
    },
    width: 312.652,
    height: 26.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 769.211,
    y: 681.491,
    style: {
      opacity: 0.5,
      fill: "#F8C48B"
    },
    width: 122.587,
    height: 1090.345
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M597.086,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.958,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C586.582,1277.627,597.086,1288.131,597.086,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M612.887,1194.806c0-17.499-17.57-31.685-39.243-31.685c-21.674,0-39.244,14.186-39.244,31.685 c0,0.045,0.002,0.089,0.002,0.134H534.4v97.994h78.487v-97.994h-0.002C612.885,1194.895,612.887,1194.851,612.887,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M606.76,1196.779c0-15.341-14.827-27.775-33.117-27.775c-18.29,0-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C606.759,1196.856,606.76,1196.818,606.76,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.096,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.624,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.096,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1785.063 637.9419)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.096,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1822.8813 675.7603)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M606.76,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C575.542,1265.289,592.923,1235.1,606.76,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M726.42,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.958,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C715.916,1277.627,726.42,1288.131,726.42,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M742.221,1194.806c0-17.499-17.57-31.685-39.244-31.685c-21.673,0-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C742.219,1194.895,742.221,1194.851,742.221,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M736.095,1196.779c0-15.341-14.827-27.775-33.117-27.775c-18.289,0-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C736.093,1196.856,736.095,1196.818,736.095,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.431,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.958,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.43,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1914.3972 508.6077)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.43,
    y: 1212.84,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1952.2156 546.426)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M736.095,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C704.875,1265.289,722.257,1235.1,736.095,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M597.086,1541.2c0,12.957-10.504,23.461-23.461,23.461c-12.958,0-23.461-10.504-23.461-23.461 c0-12.958,10.504-23.462,23.461-23.462C586.582,1517.738,597.086,1528.242,597.086,1541.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M612.887,1434.917c0-17.498-17.57-31.684-39.243-31.684c-21.674,0-39.244,14.186-39.244,31.684 c0,0.045,0.002,0.09,0.002,0.134H534.4v97.994h78.487v-97.994h-0.002C612.885,1435.007,612.887,1434.962,612.887,1434.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M606.76,1436.891c0-15.34-14.827-27.775-33.117-27.775c-18.29,0-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C606.759,1436.969,606.76,1436.93,606.76,1436.891z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.096,
    y: 1404.035,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.624,
    y: 1533.045,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.096,
    y: 1415.132,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2025.1743 878.0532)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.096,
    y: 1452.951,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2062.9927 915.8716)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M606.76,1451.31v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.84-21.09-25.878l-45.144,69.507v46.51h22.576C575.542,1505.4,592.923,1475.212,606.76,1451.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M726.42,1541.2c0,12.957-10.504,23.461-23.461,23.461c-12.958,0-23.461-10.504-23.461-23.461 c0-12.958,10.504-23.462,23.461-23.462C715.916,1517.738,726.42,1528.242,726.42,1541.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M742.221,1434.917c0-17.498-17.57-31.684-39.244-31.684c-21.673,0-39.243,14.186-39.243,31.684 c0,0.045,0.002,0.09,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C742.219,1435.007,742.221,1434.962,742.221,1434.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M736.095,1436.891c0-15.34-14.827-27.775-33.117-27.775c-18.289,0-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C736.093,1436.969,736.095,1436.93,736.095,1436.891z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.431,
    y: 1404.035,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.958,
    y: 1533.045,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.43,
    y: 1415.133,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2154.5085 748.7189)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.43,
    y: 1452.951,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2192.3269 786.5374)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M736.095,1451.31v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.748-21.84-21.09-25.878l-45.144,69.507v46.51h22.576C704.875,1505.4,722.257,1475.212,736.095,1451.31z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF5EB"
    },
    points: "745.852,661.692 740.106,661.692 490.299,661.692 490.299,682.916 740.106,682.916  745.852,682.916 916.54,682.916 916.54,661.692  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M669.398,955.878c0,16.475-13.355,29.83-29.83,29.83c-16.475,0-29.83-13.355-29.83-29.83 s13.355-29.83,29.83-29.83C656.043,926.048,669.398,939.404,669.398,955.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M689.488,820.745c0-22.249-22.339-40.285-49.896-40.285c-27.557,0-49.896,18.036-49.896,40.285 c0,0.057,0.002,0.113,0.003,0.17h-0.003V945.51h99.792V820.915h-0.003C689.486,820.858,689.488,820.802,689.488,820.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M681.699,823.254c0-19.504-18.852-35.315-42.106-35.315c-23.254,0-42.107,15.811-42.107,35.315 c0,0.05,0.003,0.099,0.003,0.149h-0.003V937.86h84.213V823.403h-0.002C681.697,823.354,681.699,823.304,681.699,823.254z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.625,
    y: 781.48,
    style: {
      fill: "#FCF5EB"
    },
    width: 3.724,
    height: 162.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.538,
    y: 945.51,
    style: {
      fill: "#F2E3D1"
    },
    width: 122.951,
    height: 10.369
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.625,
    y: 795.59,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1481.4612 202.4876)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.724,
    height: 92.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.625,
    y: 843.674,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1529.5452 250.5716)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.724,
    height: 92.769
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M681.535,841.732v-18.173h-0.003c0-0.049,0.003-0.099,0.003-0.148 c0-14.969-11.117-27.752-26.799-32.884l-57.364,88.323v59.1h28.688C641.865,910.466,663.952,872.105,681.535,841.732z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#F8C48B"
    },
    d: "M769.211,661.692c2.812,0.118-67.289-231.559-67.289-231.559h67.289l119.59,231.559 H769.211z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF5EB"
    },
    points: "719.43,414.832 717.262,414.832 623.007,414.832 623.007,436.057 717.262,436.057  719.43,436.057 783.831,436.057 783.831,414.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "703.435,150.833 703.419,150.659 630.88,414.832 672.242,414.832 705.543,414.904  705.543,414.95 775.959,414.95  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "2077.175,1033.95 2077.175,819.261 878.043,819.261 815.322,1033.95 1296.665,1033.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B75742"
    },
    points: "1951.776,1033.95 1951.776,819.261 2368.447,819.261 2430.876,1033.95 1951.782,1033.95  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.806,
    y: 802.953,
    style: {
      fill: "#F2E3D1"
    },
    width: 1518.834,
    height: 32.615
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1949.332,
    y: 1041.75,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4380.1992 2817.834)",
    style: {
      fill: "#F8C48B"
    },
    width: 481.535,
    height: 734.334
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.261,
    y: 1041.75,
    style: {
      fill: "#F8C48B"
    },
    width: 481.535,
    height: 734.334
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.795,
    y: 1054.616,
    style: {
      fill: "#F8C48B"
    },
    width: 655.079,
    height: 721.468
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.961,
    y: 1771.824,
    style: {
      fill: "#184655"
    },
    width: 2930.578,
    height: 7.896
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF5EB"
    },
    points: "1787.578,1033.95 1765.304,1033.95 796.775,1033.95 796.775,1055.174 1765.304,1055.174  1787.578,1055.174 2449.353,1055.174 2449.353,1033.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B4234"
    },
    points: "1949.509,1648.688 1949.509,1721.227 1311.248,1721.227 1311.248,1648.688  815.261,1648.688 815.261,1772.398 2430.876,1772.398 2430.876,1648.688  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1719.537,
    y: 1054.874,
    style: {
      fill: "#FCF5EB"
    },
    width: 71.978,
    height: 655.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1703.229,
    y: 1054.874,
    style: {
      fill: "#F2E3D1"
    },
    width: 104.593,
    height: 32.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.978,
    y: 1689.531,
    style: {
      fill: "#F2E3D1"
    },
    width: 91.097,
    height: 20.953
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1715.039,
    y: 1191.438,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1715.039,
    y: 1245.315,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.337
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1715.039,
    y: 1525.91,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1715.039,
    y: 1579.789,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1170.71,
    y: 1056.561,
    style: {
      opacity: 0.5,
      fill: "#F8C48B"
    },
    width: 84.911,
    height: 582.005
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1993.389,
    y: 1056.561,
    style: {
      opacity: 0.5,
      fill: "#F8C48B"
    },
    width: 84.91,
    height: 582.005
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1454.402,
    y: 1056.339,
    style: {
      fill: "#FCF5EB"
    },
    width: 71.977,
    height: 655.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1438.095,
    y: 1056.339,
    style: {
      fill: "#F2E3D1"
    },
    width: 104.592,
    height: 32.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1444.842,
    y: 1690.996,
    style: {
      fill: "#F2E3D1"
    },
    width: 91.096,
    height: 20.952
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.903,
    y: 1192.902,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.903,
    y: 1246.78,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.903,
    y: 1527.375,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.903,
    y: 1581.254,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1176.896,
    y: 1738.097,
    style: {
      fill: "#F2E3D1"
    },
    width: 894.094,
    height: 34.302
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212.322,
    y: 1704.357,
    style: {
      fill: "#FCF5EB"
    },
    width: 823.241,
    height: 33.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.765,
    y: 1638.565,
    style: {
      fill: "#F2E3D1"
    },
    width: 463.917,
    height: 28.679
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1987.203,
    y: 1638.565,
    style: {
      fill: "#F2E3D1"
    },
    width: 463.916,
    height: 28.679
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1651.375,1339.781c0,16.565-13.428,29.994-29.993,29.994c-16.564,0-29.993-13.429-29.993-29.994 c0-16.564,13.429-29.993,29.993-29.993C1637.947,1309.788,1651.375,1323.217,1651.375,1339.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1671.576,1203.908c0-22.371-22.462-40.506-50.17-40.506s-50.169,18.135-50.169,40.506 c0,0.057,0.002,0.113,0.002,0.171h-0.002v125.277h100.339v-125.277h-0.003C1671.573,1204.021,1671.576,1203.965,1671.576,1203.908 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1663.743,1206.431c0-19.61-18.955-35.509-42.337-35.509c-23.382,0-42.337,15.898-42.337,35.509 c0,0.05,0.002,0.1,0.002,0.149h-0.002v115.085h84.674V1206.58h-0.002C1663.741,1206.53,1663.743,1206.48,1663.743,1206.431z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1619.428,
    y: 1164.428,
    style: {
      fill: "#FCF5EB"
    },
    width: 3.745,
    height: 163.732
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560.018,
    y: 1329.356,
    style: {
      fill: "#F2E3D1"
    },
    width: 123.624,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1619.427,
    y: 1178.615,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2846.5535 -396.0466)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.745,
    height: 93.277
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1619.427,
    y: 1226.963,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2894.9011 -347.699)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.745,
    height: 93.277
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M910.862,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.958,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C900.358,1277.627,910.862,1288.131,910.862,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M926.663,1194.806c0-17.499-17.57-31.685-39.243-31.685c-21.674,0-39.244,14.186-39.244,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C926.661,1194.895,926.663,1194.851,926.663,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M920.537,1196.779c0-15.341-14.827-27.775-33.117-27.775c-18.29,0-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C920.535,1196.856,920.537,1196.818,920.537,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.872,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.4,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.873,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2098.8394 324.1656)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.872,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2136.6577 361.9839)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M920.537,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C889.318,1265.289,906.699,1235.1,920.537,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1052.487,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.957,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C1041.983,1277.627,1052.487,1288.131,1052.487,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1068.288,1194.806c0-17.499-17.57-31.685-39.244-31.685s-39.243,14.186-39.243,31.685 c0,0.045,0.001,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C1068.286,1194.895,1068.288,1194.851,1068.288,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1062.161,1196.779c0-15.341-14.827-27.775-33.117-27.775s-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.233v-90.021h-0.001C1062.16,1196.856,1062.161,1196.818,1062.161,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.497,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.025,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.497,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2240.4639 182.541)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.497,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2278.2822 220.3593)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1062.161,1211.197v-14.301h-0.001c0-0.039,0.001-0.078,0.001-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C1030.942,1265.289,1048.324,1235.1,1062.161,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1194.111,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.958,0-23.462-10.505-23.462-23.462 s10.504-23.461,23.462-23.461C1183.607,1277.627,1194.111,1288.131,1194.111,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1209.913,1194.806c0-17.499-17.57-31.685-39.244-31.685c-21.673,0-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C1209.911,1194.895,1209.913,1194.851,1209.913,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1203.786,1196.779c0-15.341-14.827-27.775-33.117-27.775s-33.117,12.435-33.117,27.775 c0,0.039,0.001,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C1203.784,1196.856,1203.786,1196.818,1203.786,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.122,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1122.649,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.122,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2382.0884 40.9165)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.122,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2419.9067 78.7348)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1203.786,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C1172.567,1265.289,1189.949,1235.1,1203.786,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M910.862,1535.729c0,12.958-10.504,23.462-23.461,23.462c-12.958,0-23.461-10.504-23.461-23.462 c0-12.957,10.504-23.461,23.461-23.461C900.358,1512.268,910.862,1522.771,910.862,1535.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M926.663,1429.446c0-17.499-17.57-31.685-39.243-31.685c-21.674,0-39.244,14.186-39.244,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C926.661,1429.535,926.663,1429.491,926.663,1429.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M920.537,1431.42c0-15.34-14.827-27.775-33.117-27.775c-18.29,0-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C920.535,1431.498,920.537,1431.459,920.537,1431.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.872,
    y: 1398.564,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.4,
    y: 1527.574,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.873,
    y: 1409.662,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2333.48 558.8062)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.873,
    y: 1447.48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2371.2983 596.6246)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M920.537,1445.839v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.508v46.509h22.576C889.318,1499.93,906.699,1469.741,920.537,1445.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1052.487,1535.729c0,12.958-10.504,23.462-23.461,23.462c-12.957,0-23.461-10.504-23.461-23.462 c0-12.957,10.504-23.461,23.461-23.461C1041.983,1512.268,1052.487,1522.771,1052.487,1535.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1068.288,1429.446c0-17.499-17.57-31.685-39.244-31.685s-39.243,14.186-39.243,31.685 c0,0.045,0.001,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C1068.286,1429.535,1068.288,1429.491,1068.288,1429.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1062.161,1431.42c0-15.34-14.827-27.775-33.117-27.775s-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.233v-90.021h-0.001C1062.16,1431.498,1062.161,1431.459,1062.161,1431.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.497,
    y: 1398.564,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.025,
    y: 1527.574,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.497,
    y: 1409.662,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2475.1045 417.1816)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.497,
    y: 1447.48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2512.9229 455)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1062.161,1445.839v-14.302h-0.001c0-0.039,0.001-0.078,0.001-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.508v46.509h22.576C1030.942,1499.93,1048.324,1469.741,1062.161,1445.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1194.111,1535.729c0,12.958-10.504,23.462-23.461,23.462c-12.958,0-23.462-10.504-23.462-23.462 c0-12.957,10.504-23.461,23.462-23.461C1183.607,1512.268,1194.111,1522.771,1194.111,1535.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1209.913,1429.446c0-17.499-17.57-31.685-39.244-31.685c-21.673,0-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C1209.911,1429.535,1209.913,1429.491,1209.913,1429.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1203.786,1431.42c0-15.34-14.827-27.775-33.117-27.775s-33.117,12.436-33.117,27.775 c0,0.039,0.001,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C1203.784,1431.498,1203.786,1431.459,1203.786,1431.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.122,
    y: 1398.564,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1122.649,
    y: 1527.574,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.122,
    y: 1409.662,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2616.729 275.5571)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.122,
    y: 1447.48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2654.5474 313.3755)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1203.786,1445.839v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.09-25.879l-45.144,69.508v46.509h22.576C1172.567,1499.93,1189.949,1469.741,1203.786,1445.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2100.738,1301.088c0,12.957-10.505,23.462-23.462,23.462s-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461S2100.738,1288.131,2100.738,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2116.539,1194.806c0-17.499-17.57-31.685-39.244-31.685c-21.673,0-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C2116.537,1194.895,2116.539,1194.851,2116.539,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2110.412,1196.779c0-15.341-14.826-27.775-33.117-27.775c-18.289,0-33.116,12.435-33.116,27.775 c0,0.039,0.001,0.077,0.002,0.117h-0.002v90.021h66.233v-90.021h-0.002C2110.41,1196.856,2110.412,1196.818,2110.412,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075.748,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2029.276,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.7,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075.748,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3288.7148 -865.7099)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075.748,
    y: 1212.84,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3326.5332 -827.8915)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2110.412,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C2079.193,1265.289,2096.575,1235.1,2110.412,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1879.183,1301.088c0,12.957-10.504,23.462-23.462,23.462c-12.957,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C1868.679,1277.627,1879.183,1288.131,1879.183,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1894.983,1194.806c0-17.499-17.569-31.685-39.243-31.685c-21.674,0-39.243,14.186-39.243,31.685 c0,0.045,0.001,0.089,0.002,0.134h-0.002v97.994h78.486v-97.994h-0.002C1894.981,1194.895,1894.983,1194.851,1894.983,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1888.856,1196.779c0-15.341-14.826-27.775-33.116-27.775s-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.233v-90.021h-0.001C1888.855,1196.856,1888.856,1196.818,1888.856,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.192,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1807.721,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.193,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3067.1597 -644.1548)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.193,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3104.978 -606.3364)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1888.856,1211.197v-14.301h-0.001c0-0.039,0.001-0.078,0.001-0.117 c0-11.78-8.748-21.841-21.089-25.879l-45.145,69.507v46.51h22.576C1857.638,1265.289,1875.02,1235.1,1888.856,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1879.183,1544.574c0,12.957-10.504,23.461-23.462,23.461c-12.957,0-23.461-10.504-23.461-23.461 c0-12.958,10.504-23.462,23.461-23.462C1868.679,1521.112,1879.183,1531.616,1879.183,1544.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1894.983,1438.291c0-17.498-17.569-31.684-39.243-31.684c-21.674,0-39.243,14.186-39.243,31.684 c0,0.045,0.001,0.09,0.002,0.134h-0.002v97.994h78.486v-97.994h-0.002C1894.981,1438.381,1894.983,1438.336,1894.983,1438.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1888.856,1440.265c0-15.34-14.826-27.775-33.116-27.775s-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.233v-90.021h-0.001C1888.855,1440.343,1888.856,1440.304,1888.856,1440.265z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.192,
    y: 1407.409,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 128.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1807.721,
    y: 1536.419,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.192,
    y: 1418.507,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3310.6455 -400.669)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.193,
    y: 1456.325,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3348.4634 -362.8511)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1888.856,1454.684v-14.302h-0.001c0-0.039,0.001-0.078,0.001-0.117 c0-11.78-8.748-21.84-21.089-25.878l-45.145,69.507v46.51h22.576C1857.638,1508.774,1875.02,1478.586,1888.856,1454.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1412.454,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.957,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C1401.95,1277.627,1412.454,1288.131,1412.454,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1428.255,1194.806c0-17.499-17.57-31.685-39.244-31.685c-21.673,0-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C1428.253,1194.895,1428.255,1194.851,1428.255,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1422.129,1196.779c0-15.341-14.827-27.775-33.117-27.775c-18.29,0-33.117,12.435-33.117,27.775 c0,0.039,0.001,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C1422.127,1196.856,1422.129,1196.818,1422.129,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1387.465,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1340.993,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1387.465,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2600.4314 -177.4265)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1387.464,
    y: 1212.84,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2638.2498 -139.6081)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1422.129,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.09-25.879l-45.144,69.507v46.51h22.576C1390.91,1265.289,1408.292,1235.1,1422.129,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1412.454,1544.574c0,12.957-10.504,23.461-23.461,23.461c-12.957,0-23.461-10.504-23.461-23.461 c0-12.958,10.504-23.462,23.461-23.462C1401.95,1521.112,1412.454,1531.616,1412.454,1544.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1428.255,1438.291c0-17.498-17.57-31.684-39.244-31.684c-21.673,0-39.243,14.186-39.243,31.684 c0,0.045,0.002,0.09,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C1428.253,1438.381,1428.255,1438.336,1428.255,1438.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1422.129,1440.265c0-15.34-14.827-27.775-33.117-27.775c-18.29,0-33.117,12.436-33.117,27.775 c0,0.039,0.001,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C1422.127,1440.343,1422.129,1440.304,1422.129,1440.265z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1387.465,
    y: 1407.409,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1340.993,
    y: 1536.419,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.155
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1387.464,
    y: 1418.507,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2843.9172 66.0593)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 72.962
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1387.465,
    y: 1456.325,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2881.7351 103.8773)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1422.129,1454.684v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.84-21.09-25.878l-45.144,69.507v46.51h22.576C1390.91,1508.774,1408.292,1478.586,1422.129,1454.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2242.362,1301.088c0,12.957-10.504,23.462-23.461,23.462c-12.958,0-23.462-10.505-23.462-23.462 s10.504-23.461,23.462-23.461C2231.858,1277.627,2242.362,1288.131,2242.362,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2258.164,1194.806c0-17.499-17.57-31.685-39.244-31.685s-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.003C2258.162,1194.895,2258.164,1194.851,2258.164,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2252.037,1196.779c0-15.341-14.827-27.775-33.117-27.775s-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C2252.035,1196.856,2252.037,1196.818,2252.037,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.373,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2170.9,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.373,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3430.3394 -1007.3345)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.373,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3468.1577 -969.5161)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2252.037,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.09-25.879l-45.145,69.507v46.51h22.576C2220.818,1265.289,2238.199,1235.1,2252.037,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2383.987,1301.088c0,12.957-10.504,23.462-23.462,23.462c-12.957,0-23.461-10.505-23.461-23.462 s10.504-23.461,23.461-23.461C2373.483,1277.627,2383.987,1288.131,2383.987,1301.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2399.788,1194.806c0-17.499-17.569-31.685-39.243-31.685s-39.244,14.186-39.244,31.685 c0,0.045,0.002,0.089,0.003,0.134h-0.003v97.994h78.487v-97.994h-0.002C2399.786,1194.895,2399.788,1194.851,2399.788,1194.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2393.662,1196.779c0-15.341-14.827-27.775-33.117-27.775s-33.117,12.435-33.117,27.775 c0,0.039,0.002,0.077,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C2393.66,1196.856,2393.662,1196.818,2393.662,1196.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2358.998,
    y: 1163.924,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.928,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2312.525,
    y: 1292.934,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2358.998,
    y: 1175.021,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3571.9644 -1148.9595)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2358.998,
    y: 1212.839,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3609.7827 -1111.1411)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2393.662,1211.197v-14.301h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.091-25.879l-45.144,69.507v46.51h22.576C2362.443,1265.289,2379.824,1235.1,2393.662,1211.197z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2100.738,1535.729c0,12.958-10.505,23.462-23.462,23.462s-23.461-10.504-23.461-23.462 c0-12.957,10.504-23.461,23.461-23.461S2100.738,1522.771,2100.738,1535.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2116.539,1429.446c0-17.499-17.57-31.685-39.244-31.685c-21.673,0-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.002C2116.537,1429.535,2116.539,1429.491,2116.539,1429.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2110.412,1431.42c0-15.34-14.826-27.775-33.117-27.775c-18.289,0-33.116,12.436-33.116,27.775 c0,0.039,0.001,0.078,0.002,0.117h-0.002v90.021h66.233v-90.021h-0.002C2110.41,1431.498,2110.412,1431.459,2110.412,1431.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075.748,
    y: 1398.564,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.93,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2029.276,
    y: 1527.574,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.7,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075.748,
    y: 1409.662,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3523.3555 -631.0693)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075.748,
    y: 1447.48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3561.1738 -593.2509)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.962
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2110.412,1445.839v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.748-21.841-21.09-25.879l-45.144,69.508v46.509h22.576C2079.193,1499.93,2096.575,1469.741,2110.412,1445.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2242.362,1535.729c0,12.958-10.504,23.462-23.461,23.462c-12.958,0-23.462-10.504-23.462-23.462 c0-12.957,10.504-23.461,23.462-23.461C2231.858,1512.268,2242.362,1522.771,2242.362,1535.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2258.164,1429.446c0-17.499-17.57-31.685-39.244-31.685s-39.243,14.186-39.243,31.685 c0,0.045,0.002,0.089,0.002,0.134h-0.002v97.994h78.487v-97.994h-0.003C2258.162,1429.535,2258.164,1429.491,2258.164,1429.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2252.037,1431.42c0-15.34-14.827-27.775-33.117-27.775s-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C2252.035,1431.498,2252.037,1431.459,2252.037,1431.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.373,
    y: 1398.564,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2170.9,
    y: 1527.574,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.373,
    y: 1409.662,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3664.98 -772.6938)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.373,
    y: 1447.48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3702.7983 -734.8754)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2252.037,1445.839v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.09-25.879l-45.145,69.508v46.509h22.576C2220.818,1499.93,2238.199,1469.741,2252.037,1445.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2383.987,1535.729c0,12.958-10.504,23.462-23.462,23.462c-12.957,0-23.461-10.504-23.461-23.462 c0-12.957,10.504-23.461,23.461-23.461C2373.483,1512.268,2383.987,1522.771,2383.987,1535.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2399.788,1429.446c0-17.499-17.569-31.685-39.243-31.685s-39.244,14.186-39.244,31.685 c0,0.045,0.002,0.089,0.003,0.134h-0.003v97.994h78.487v-97.994h-0.002C2399.786,1429.535,2399.788,1429.491,2399.788,1429.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M2393.662,1431.42c0-15.34-14.827-27.775-33.117-27.775s-33.117,12.436-33.117,27.775 c0,0.039,0.002,0.078,0.002,0.117h-0.002v90.021h66.234v-90.021h-0.002C2393.66,1431.498,2393.662,1431.459,2393.662,1431.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2358.998,
    y: 1398.564,
    style: {
      fill: "#FCF5EB"
    },
    width: 2.928,
    height: 128.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2312.525,
    y: 1527.574,
    style: {
      fill: "#F2E3D1"
    },
    width: 96.701,
    height: 8.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2358.998,
    y: 1409.662,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3806.605 -914.3188)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2358.998,
    y: 1447.48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3844.4233 -876.5004)",
    style: {
      fill: "#FCF5EB"
    },
    width: 2.929,
    height: 72.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M2393.662,1445.839v-14.302h-0.002c0-0.039,0.002-0.078,0.002-0.117 c0-11.78-8.749-21.841-21.091-25.879l-45.144,69.508v46.509h22.576C2362.443,1499.93,2379.824,1469.741,2393.662,1445.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1685.867,1528.244c0-33.482-28.215-60.625-63.019-60.625c-34.805,0-63.02,27.143-63.02,60.625 c0,0.086,0.003,0.171,0.003,0.256h-0.003v187.504h126.039V1528.5h-0.003C1685.864,1528.415,1685.867,1528.33,1685.867,1528.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1676.029,1532.021c0-29.352-23.811-53.146-53.181-53.146c-29.371,0-53.181,23.794-53.181,53.146 c0,0.075,0.003,0.149,0.003,0.224h-0.003v172.248h106.362v-172.248h-0.003C1676.026,1532.17,1676.029,1532.096,1676.029,1532.021z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.006,
    y: 1473.242,
    style: {
      fill: "#FCF5EB"
    },
    width: 6.186,
    height: 239.55
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1569.667,1704.309h12.112l73.521-214.391c-8.979-6.923-20.233-11.044-32.452-11.044 c-0.866,0-1.727,0.023-2.583,0.063l-50.598,147.547V1704.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1675.988,1532.43h-0.003c0.001-0.075,0.003-0.149,0.003-0.224 c0-9.59-2.545-18.585-6.995-26.349l-68.055,198.451h28.086l46.964-136.95V1532.43z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1334.346,
    y: 716.918,
    style: {
      fill: "#F8C48B"
    },
    width: 571.32,
    height: 316.025
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1650.813,947.28c0,16.565-13.428,29.994-29.994,29.994c-16.564,0-29.993-13.429-29.993-29.994 c0-16.565,13.429-29.993,29.993-29.993C1637.385,917.287,1650.813,930.715,1650.813,947.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1671.014,811.406c0-22.37-22.462-40.505-50.17-40.505c-27.708,0-50.169,18.135-50.169,40.505 c0,0.058,0.002,0.114,0.003,0.171h-0.003v125.277h100.339V811.578h-0.003C1671.011,811.521,1671.014,811.464,1671.014,811.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1663.182,813.929c0-19.611-18.956-35.508-42.338-35.508c-23.382,0-42.337,15.898-42.337,35.508 c0,0.05,0.002,0.1,0.002,0.15h-0.002v115.084h84.675V814.079h-0.003C1663.179,814.029,1663.182,813.979,1663.182,813.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1618.866,
    y: 771.926,
    style: {
      fill: "#FCF5EB"
    },
    width: 3.745,
    height: 163.732
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1559.455,
    y: 936.854,
    style: {
      fill: "#F2E3D1"
    },
    width: 123.624,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1618.866,
    y: 786.114,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2453.4897 -787.9858)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 93.276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1618.866,
    y: 834.461,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2501.8374 -739.6382)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 93.276
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1808.826,947.28c0,16.565-13.429,29.994-29.994,29.994c-16.564,0-29.993-13.429-29.993-29.994 c0-16.565,13.429-29.993,29.993-29.993C1795.397,917.287,1808.826,930.715,1808.826,947.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1829.026,811.406c0-22.37-22.462-40.505-50.17-40.505s-50.169,18.135-50.169,40.505 c0,0.058,0.002,0.114,0.002,0.171h-0.002v125.277h100.339V811.578h-0.003C1829.023,811.521,1829.026,811.464,1829.026,811.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1821.193,813.929c0-19.611-18.955-35.508-42.337-35.508s-42.337,15.898-42.337,35.508 c0,0.05,0.002,0.1,0.002,0.15h-0.002v115.084h84.674V814.079h-0.002C1821.191,814.029,1821.193,813.979,1821.193,813.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1776.879,
    y: 771.926,
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 163.732
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1717.468,
    y: 936.854,
    style: {
      fill: "#F2E3D1"
    },
    width: 123.625,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1776.878,
    y: 786.114,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2611.5024 -945.9985)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 93.276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1776.878,
    y: 834.461,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2659.8501 -897.6509)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 93.276
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF5EB"
    },
    points: "1681.793,696.556 1673.842,696.556 1328.091,696.556 1328.091,717.78 1673.842,717.78  1681.793,717.78 1918.037,717.78 1918.037,696.556  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1252.247,
    y: 1054.874,
    style: {
      fill: "#FCF5EB"
    },
    width: 71.978,
    height: 655.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.939,
    y: 1054.874,
    style: {
      fill: "#F2E3D1"
    },
    width: 104.592,
    height: 32.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.687,
    y: 1689.531,
    style: {
      fill: "#F2E3D1"
    },
    width: 91.097,
    height: 20.953
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.748,
    y: 1191.438,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.748,
    y: 1245.315,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.337
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.748,
    y: 1525.91,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.748,
    y: 1579.789,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1921.692,
    y: 1056.339,
    style: {
      fill: "#FCF5EB"
    },
    width: 71.978,
    height: 655.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1905.385,
    y: 1056.339,
    style: {
      fill: "#F2E3D1"
    },
    width: 104.593,
    height: 32.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1912.133,
    y: 1690.996,
    style: {
      fill: "#F2E3D1"
    },
    width: 91.097,
    height: 20.952
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1917.193,
    y: 1192.902,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1917.193,
    y: 1246.78,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1917.193,
    y: 1527.375,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1917.193,
    y: 1581.254,
    style: {
      fill: "#F2E3D1"
    },
    width: 80.975,
    height: 13.336
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1492.8,947.28c0,16.565-13.429,29.994-29.994,29.994s-29.993-13.429-29.993-29.994 c0-16.565,13.428-29.993,29.993-29.993S1492.8,930.715,1492.8,947.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M1513,811.406c0-22.37-22.462-40.505-50.169-40.505c-27.708,0-50.169,18.135-50.169,40.505 c0,0.058,0.002,0.114,0.002,0.171h-0.002v125.277H1513V811.578h-0.002C1512.998,811.521,1513,811.464,1513,811.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E6193"
    },
    d: "M1505.168,813.929c0-19.611-18.955-35.508-42.337-35.508c-23.382,0-42.337,15.898-42.337,35.508 c0,0.05,0.002,0.1,0.002,0.15h-0.002v115.084h84.674V814.079h-0.002C1505.166,814.029,1505.168,813.979,1505.168,813.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460.853,
    y: 771.926,
    style: {
      fill: "#FCF5EB"
    },
    width: 3.745,
    height: 163.732
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401.442,
    y: 936.854,
    style: {
      fill: "#F2E3D1"
    },
    width: 123.624,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460.853,
    y: 786.114,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2295.4768 -629.9729)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 93.277
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460.853,
    y: 834.461,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2343.8245 -581.6252)",
    style: {
      fill: "#FCF5EB"
    },
    width: 3.744,
    height: 93.277
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1505.003,832.509v-18.273h-0.002c0-0.05,0.002-0.1,0.002-0.149 c0-15.051-11.178-27.905-26.946-33.064l-57.679,88.807v59.423h28.845C1465.116,901.619,1487.324,863.048,1505.003,832.509z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1663.578,832.509v-18.273h-0.002c0-0.05,0.002-0.1,0.002-0.149 c0-15.051-11.178-27.905-26.945-33.064l-57.679,88.807v59.423h28.845C1623.691,901.619,1645.899,863.048,1663.578,832.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1663.578,1225.01v-18.272h-0.002c0-0.05,0.002-0.1,0.002-0.149 c0-15.051-11.178-27.904-26.945-33.063l-57.679,88.807v59.423h28.845C1623.691,1294.121,1645.899,1255.549,1663.578,1225.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FCF5EB"
    },
    d: "M1822.153,832.509v-18.273h-0.002c0-0.05,0.002-0.1,0.002-0.149 c0-15.051-11.178-27.905-26.945-33.064l-57.679,88.807v59.423h28.845C1782.267,901.619,1804.475,863.048,1822.153,832.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#F4B98C"
    },
    d: "M2028.578,1926.104c39.281,0.005,324.021-55.614,363.156-52.636 c95.157,7.241,190.281,31.989,284.68,19.181c85.668-11.625,163.766-53.525,250.016-61.116c28.404-2.499,57.447-1.24,85.063-7.611 c27.354-6.312,82.8-44.202,82.8-44.202l-2894.278-0.562c0,0,20.554,53.909,74.942,65.493 c255.948,54.513,751.09,8.03,1013.349,28.857c70.362,5.588,173.765,46.529,244.076,52.596 C1607.266,1932.564,1990.078,1926.099,2028.578,1926.104z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2029.799,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.773,
    height: 41.324
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2166.639,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.771,
    height: 41.324
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2176.834,1711.295h-154.458c-1.163,0-2.106,0.943-2.106,2.107v4.002 c0,1.164,0.943,2.106,2.106,2.106h154.458c1.164,0,2.106-0.942,2.106-2.106v-4.002 C2178.94,1712.238,2177.998,1711.295,2176.834,1711.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2176.834,1722.963h-154.458c-1.163,0-2.106,0.943-2.106,2.106v4.003 c0,1.163,0.943,2.106,2.106,2.106h154.458c1.164,0,2.106-0.943,2.106-2.106v-4.003 C2178.94,1723.906,2177.998,1722.963,2176.834,1722.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2176.834,1734.63h-154.458c-1.163,0-2.106,0.943-2.106,2.106v4.003 c0,1.163,0.943,2.106,2.106,2.106h154.458c1.164,0,2.106-0.943,2.106-2.106v-4.003 C2178.94,1735.573,2177.998,1734.63,2176.834,1734.63z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2179.713,1761.494h-160.216v-0.645c0-3.146,2.55-5.696,5.695-5.696h148.825 c3.146,0,5.695,2.55,5.695,5.696V1761.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31535B"
    },
    d: "M2179.826,1760.665h-160.768c-0.713,0-1.291,0.578-1.291,1.292v0.293 c0,0.713,0.578,1.292,1.291,1.292h160.768c0.713,0,1.291-0.579,1.291-1.292v-0.293 C2181.117,1761.243,2180.539,1760.665,2179.826,1760.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M2121.875,1734.9c2.178-1.193,20.463-11.223,21.14-11.887c0.609-0.6,9.107-14.229,9.107-14.229 l-7.443-1.743l-7.388,12.772c-0.612,0.478-12.246,8.91-12.246,8.91s-2.093,1.604-3.385,2.475 c-0.392,0.021-0.763,0.037-1.071,0.042c-0.677-0.03-1.273-0.152-1.784-0.275c-0.643-0.156-1.965-0.304-2.282-0.256 c-0.368,0.055-1.123,0.193-1.577,0.282c-0.453,0.09-0.988,0.176-1.223,0.252c-0.143,0.046-0.478,0.021-0.718-0.005 c-0.357-0.04-0.579,0.383-0.341,0.651c0.225,0.255,0.705,0.321,1.005,0.361c0.845,0.113,2.165-0.197,2.143-0.069 c-0.022,0.127-1.96,1.368-2.172,1.524c-0.212,0.155-2.455,1.609-2.796,2.036c-0.342,0.427-0.134,0.71,0.18,0.675 c0.27-0.03,3.516-1.81,3.516-1.81s0.415-0.227,0.36,0.021c-0.054,0.247-2.999,1.869-3.394,2.192 c-0.394,0.324-0.504,0.726-0.034,0.826c0.573,0.122,3.609-1.802,3.609-1.802s0.385-0.235,0.421-0.044 c0.037,0.191-2.492,1.53-2.66,1.763c-0.169,0.233-0.104,0.612,0.345,0.615c0.527,0.004,3.224-1.738,3.224-1.738 s0.242-0.074,0.211,0.068c-0.029,0.142-2.104,1.437-2.213,1.75c-0.092,0.264,0.144,0.351,0.144,0.351 c0.46,0.294,2.302-1.243,3.355-1.686C2118.955,1736.485,2121.807,1734.938,2121.875,1734.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M2144.006,1701.679c0,0-1.691,0.571-3.921,6.019c-2.081,5.086-3.77,10.696-3.77,10.696l5.674,4.446 c0,0,2.054-11.563,2.311-11.963C2144.558,1710.478,2144.006,1701.679,2144.006,1701.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2134.043,1791.479c0,0,0.269,4.439,0.271,4.448c0.099,0.564,0.486,1.956,0.486,2.469 c0,1.925-9.14-1.634-7.092-2.487c0.187-0.077,1.157-0.661,1.218-1.315c0.095-1.01,0.332-3.052,0.332-3.052L2134.043,1791.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M2127.731,1795.892c0,0,2.146,0.589,3.245,0.735c1.099,0.147,2.548-1.092,3.325-0.757 c0.855,0.368,0.821,3.686,0.821,3.686s-11.507,0.944-14.743-0.033C2119.099,1799.136,2123.344,1797.263,2127.731,1795.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2118.527,1791.479c0,0,0.269,4.439,0.27,4.448c0.1,0.564,0.487,1.956,0.487,2.469 c0,1.925-9.14-1.634-7.092-2.487c0.186-0.077,1.569-0.321,1.63-0.977c0.095-1.01,0.27-4.131,0.27-4.131L2118.527,1791.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M2112.215,1795.892c0,0,2.146,0.589,3.245,0.735c1.099,0.147,2.548-1.092,3.325-0.757 c0.855,0.368,0.822,3.686,0.822,3.686s-11.508,0.944-14.743-0.033C2103.582,1799.136,2107.828,1797.263,2112.215,1795.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2148.213,1744.918l-21.848,0.094c0,0-9.869-0.259-11.43,3.154s-1.665,43.874-1.665,43.874 s5.164,0.289,5.434,0l6.512-22.573c0.634-2.199,0.851-4.499,0.636-6.777l-0.566-6.036l9.016,0.461c0,0,10.22-0.163,13.59-3.552 C2151.26,1750.172,2148.213,1744.918,2148.213,1744.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2163.023,1742.509l-23.492,1.44c0,0-10.109,0.821-11.67,4.234s0.522,43.856,0.522,43.856 s5.942,0.257,5.93,0c-0.014-0.306,2.803-16.647,4.146-22.893c0.427-1.981,0.576-4.013,0.444-6.035l-0.345-5.288 c0,0,24.121-0.479,25.205-1.568C2167.133,1752.866,2163.023,1742.509,2163.023,1742.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M2144.006,1701.679c3.329-0.771,9.477-0.878,9.477-0.878s3.873-0.366,5.1-0.014 c1.807,0.52,5.234,0.932,5.021,8.908c-0.152,5.707-0.105,24.541-0.093,34.095l-23.493,0.13 C2142.254,1724.706,2140.854,1702.408,2144.006,1701.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2150.748,1693.79l3.213,6.983c0,0-3.09,4.735-5.71,4.691c-2.198-0.036-1.637-3.252-1.637-3.252 s-0.064-4.211-0.99-6.157S2150.748,1693.79,2150.748,1693.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2150.232,1696.466c-0.881,0.822-2.332,1.887-3.871,2.522c-0.146-1.066-0.375-2.172-0.737-2.933 c-0.427-0.898,0.632-1.449,1.896-1.783c1.685-0.329,3.229-0.482,3.229-0.482l0.617,1.342 C2151.155,1695.574,2150.525,1696.192,2150.232,1696.466z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2149.625,1682.313c0.158-0.098,3.209,8.568,1.438,11.494c-1.771,2.926-6.045,4.649-8.039,3.048 c-2.205-1.771-4.104-11.371-1.083-14.63C2144.962,1678.967,2149.625,1682.313,2149.625,1682.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2142.301,1677.176c2.855-0.009,4.977,1.297,5.777,1.875c1.273-0.111,3.107,0.227,5.452,2.755 c2.884,3.108,2.115,7.375,0.017,9.825c-2.098,2.45-1.601,4.674-1.601,4.674l-0.634-1.072c-0.474-0.813-0.784-1.716-0.877-2.653 c-0.056-0.563-0.062-1.182,0.064-1.719c0.334-1.415-1.736-1.88-2.488-2.843c-0.58-0.742-0.992-2.629-1.92-3.861l-0.984-0.884 c0,0-2.06-1.013-3.713-0.263C2139.74,1683.759,2138.638,1677.188,2142.301,1677.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2148.457,1689.58c0.207,1.091,0.887,1.879,1.517,1.76c0.63-0.12,0.973-1.102,0.765-2.192 c-0.207-1.092-0.886-1.88-1.516-1.761C2148.592,1687.507,2148.249,1688.488,2148.457,1689.58z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2145.275,1692.86l-3.473,0.535c0,0,0.283,1.307,1.817,1.115 C2145.49,1694.278,2145.275,1692.86,2145.275,1692.86z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M2148.85,1732.473c-0.271-0.123-0.646-0.63-2.741-1.653c-0.605-0.295-1.559-0.215-1.559-0.215 s-1.172,0.108-1.224,0.394c-0.051,0.286,0.187,0.566,0.406,0.631c0.221,0.065,0.68-0.035,0.9,0.03 c0.22,0.065,0.588,0.701,0.63,0.964c0.042,0.264-3.421,0.465-3.421,0.465s-0.996,0.01-1.327-0.014 c-0.282-0.02-1.126-0.146-1.126-0.146s-1.208-0.112-1.219,0.27c-0.006,0.226,1.041,0.628,2.109,0.849 c1.149,0.236,2.326,0.286,2.336,0.405c0.021,0.28-1.875,0.436-1.875,0.436s-0.913-0.136-1.314-0.063 c-0.549-0.179-1.502-0.202-1.482,0.265c0.004,0.086,1.294,0.497,1.294,0.497s0.87,0.103,1.282,0.179 c0.727,0.133,1.803-0.003,2.3,0.047c0.413,0.042,0.272,0.163,0.298,0.203c0.02,0.032-0.533,0.061-1.289,0.113 c-0.381,0.026-0.804,0.141-1.252,0.101c-0.416-0.036-0.992-0.003-1.339,0.026c-0.981,0.082-0.75,0.694,0.179,0.77 c0.354,0.029,0.738,0.057,1.129,0.084c1.519,0.104,2.91-0.13,2.956,0.03c0.06,0.207-2.509,0.478-2.509,0.478 s-1.338,0.549,0.033,0.658c1.592,0.127,2.817-0.111,2.871-0.125c0.362-0.093,1.741-0.029,2.947-0.556 c0.89-0.388,2.15-0.979,2.752-1.265L2148.85,1732.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M2167.033,1714.006l-6.049,2.848c0,0,1.975,5.289,2.082,5.938c0,0-9.961,7.246-14.217,9.681 l0.682,3.892c0.838-0.451,1.498-0.889,1.916-1.091c0.822-0.397,14.008-6.555,14.008-6.555s5.157-2.69,5.189-3.752 C2170.676,1723.905,2167.033,1714.006,2167.033,1714.006z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M2169.385,1717.394c0,0-4.782-11.808-6.879-14.713c-2.097-2.904-5.707-2.796-7.707-0.336 c-2,2.461,6.949,17.839,6.949,17.839L2169.385,1717.394z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2073.942,1791.666c0,0-0.238,4.341-0.239,4.35c-0.088,0.552-0.433,1.913-0.433,2.414 c0,1.883,8.118-1.598,6.299-2.432c-0.165-0.076-1.027-0.646-1.081-1.287c-0.084-0.987-0.295-2.984-0.295-2.984 L2073.942,1791.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2079.549,1795.98c0,0-1.905,0.575-2.882,0.719c-0.977,0.145-2.263-1.067-2.954-0.74 c-0.76,0.36-0.729,3.604-0.729,3.604s10.222,0.923,13.096-0.032C2087.218,1799.153,2083.446,1797.321,2079.549,1795.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2087.725,1791.666c0,0-0.238,4.341-0.239,4.35c-0.088,0.552-0.433,1.913-0.433,2.414 c0,1.883,8.118-1.598,6.299-2.432c-0.164-0.076-1.394-0.315-1.448-0.956c-0.083-0.987-0.239-4.04-0.239-4.04L2087.725,1791.666z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2093.332,1795.98c0,0-1.906,0.575-2.883,0.719c-0.977,0.145-2.264-1.067-2.953-0.74 c-0.761,0.36-0.73,3.604-0.73,3.604s10.221,0.923,13.096-0.032C2101,1799.153,2097.229,1797.321,2093.332,1795.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2061.571,1745.094l19.407,0.093c0,0,8.766-0.253,10.151,3.084 c1.386,3.338,1.057,45.727,1.057,45.727s-4.679,0.767-4.919,0.483l-5.269-25.379c-0.563-2.15-0.755-4.398-0.565-6.628 l0.504-5.902l-8.379-0.728c0,0-8.707,1.02-11.7-2.296S2061.571,1745.094,2061.571,1745.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M2048.416,1742.737l20.867,1.41c0,0,8.98,0.803,10.366,4.141s-0.885,46.09-0.885,46.09 s-5.209,0.354-5.198,0.103c0.012-0.299-2.139-19.583-3.331-25.69c-0.379-1.938-0.511-3.924-0.395-5.902l0.754-6.844 c0,0-19.382-0.122-20.344-1.188C2047.258,1751.542,2048.416,1742.737,2048.416,1742.737z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M2095.405,1722.305c0.19-0.547-2.484-0.979-2.629-1.531s3.373-0.607,3.498-1.094 c0.229-0.896-3.856-0.175-3.777-0.594c0.079-0.418,4.255-1.367,3.801-2.084s-4.228,1.434-4.344,0.947 c-0.116-0.487,3.689-1.686,3.617-2.754c-0.038-0.57-6.242,2.869-6.964,2.561c-0.723-0.308,0.765-2.996,0.189-3.392 c-0.576-0.396-2.202,5.46-2.598,5.657c-0.395,0.195-8.776,4.99-11.762,5.758c-0.367-0.994-2.992-6.26-3.316-7.199 c-1.672,1.192-3.616,1.457-5.343,2.545c1.265,3.119,5.599,10.793,6.474,11.182c2.664,1.186,12.919-7.33,14.967-8.788 c2.05-1.46,3.228-0.993,4.615-1.457S2095.216,1722.852,2095.405,1722.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2068.757,1696.879c0.124-2.974-0.317-5.91-1.655-8.679c-1.151-2.382-4-3.733-6.599-3.737 c-8.251-0.01-9.3,10.826-14.552,15.006c-1.604,1.277-3.398,2.318-4.917,3.695c-5.607,5.086-3.082,14.501,2.067,18.96 c3.572,3.094,9.188,4.853,13.592,2.434c2.299-1.263,4.043-3.361,5.287-5.661c1.764-3.264,2.901-7.029,4.156-10.508 C2067.473,1704.686,2068.592,1700.832,2068.757,1696.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2066.29,1724.838c0,0-6.161-6.28-7.747-9.009s1.08-0.952,3.803-1.67 c1.03-0.272,0.77-6.278,2.719-4.326c3.197,3.203,7.218,8.804,7.218,8.804L2066.29,1724.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2057.53,1707.078c0,0-5.53-1.085-8.054,1.011s0.541,20.729,0.538,23.818 c-0.003,3.089-1.732,11.815-1.732,11.815s7.149-0.051,20.078,0.362c0,0,0.102-19.75-0.011-21.972 c-0.113-2.221-2.598-11.307-3.285-12.28C2064.378,1708.86,2057.53,1707.078,2057.53,1707.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2057.495,1698.574c0,0-0.029,0.165-0.081,0.444c-0.251,1.342-1.217,5.793-1.869,7.017 c-0.789,1.479,2.699,6.194,6.057,5.619c0.999-0.172-0.846-4.333-0.756-4.774c0.169-0.844,0.399-1.995,0.635-3.176 c0.133-0.666,0.268-1.341,0.394-1.976c0.358-1.803,0.651-3.278,0.651-3.278L2057.495,1698.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2057.414,1699.019c0.052-0.279,0.081-0.444,0.081-0.444l5.03-0.124c0,0-0.293,1.476-0.651,3.278 c-0.126,0.631-0.26,1.303-0.392,1.965c-0.776-0.113-1.588-0.488-2.402-1.194c-0.887-0.771-1.468-1.696-1.819-2.685 C2057.323,1699.499,2057.375,1699.227,2057.414,1699.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2060.881,1687.23c0,0-2.371-0.271-3.857,1.636s-3.088,7.805,0.604,11.011 c3.691,3.206,7.34-0.423,7.881-4.271C2066.049,1691.758,2066.26,1687.092,2060.881,1687.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2066.601,1695.549c-0.44,0.85-1.181,1.32-1.652,1.051c-0.472-0.269-0.497-1.176-0.056-2.026 c0.44-0.85,1.18-1.32,1.651-1.051S2067.041,1694.699,2066.601,1695.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2061.146,1686.601c0,0-3.168,5.608-5.434,5.867c-2.267,0.259-2.564,3.239-2.564,3.239 s0.811-6.867,3.054-8.191S2061.146,1686.601,2061.146,1686.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2056.307,1693.877c0.184,0.996-0.187,1.909-0.828,2.04s-1.311-0.571-1.495-1.566 c-0.185-0.996,0.187-1.909,0.828-2.04S2056.122,1692.881,2056.307,1693.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2062.308,1697.758l-3.479-0.179c0,0,0.012,1.317,1.539,1.44 C2062.231,1699.169,2062.308,1697.758,2062.308,1697.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2062.308,1697.758l-3.479-0.179c0,0,0.012,1.317,1.539,1.44 C2062.231,1699.169,2062.308,1697.758,2062.308,1697.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2081.989,1724.961c0.19-0.548-2.485-0.979-2.63-1.532c-0.144-0.552,3.374-0.607,3.498-1.094 c0.229-0.896-3.855-0.175-3.777-0.593c0.08-0.419,4.256-1.368,3.801-2.085c-0.454-0.716-4.227,1.434-4.343,0.947 c-0.116-0.487,3.689-1.686,3.617-2.753c-0.038-0.571-6.242,2.868-6.965,2.561c-0.722-0.309,0.765-2.996,0.19-3.393 c-0.576-0.396-2.203,5.461-2.598,5.657s-8.777,4.99-11.763,5.758c-0.366-0.993-2.992-6.26-3.315-7.199 c-1.672,1.192-3.616,1.458-5.343,2.545c1.265,3.119,5.599,10.793,6.474,11.183c2.663,1.185,12.919-7.33,14.967-8.789 c2.049-1.459,3.227-0.992,4.615-1.456C2079.806,1724.254,2081.799,1725.508,2081.989,1724.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2051.561,1724.618c0,0-3.629-7.997-4.18-11.101c-0.551-3.103,2.127-6.999,4.933-6.747 c2.806,0.251,7.011,14.058,7.011,14.058L2051.561,1724.618z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 2024.348,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2173.091,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2237.503,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.773,
    height: 41.324
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2374.342,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.772,
    height: 41.324
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2384.538,1711.295H2230.08c-1.164,0-2.107,0.943-2.107,2.107v4.002 c0,1.164,0.943,2.106,2.107,2.106h154.458c1.163,0,2.106-0.942,2.106-2.106v-4.002 C2386.645,1712.238,2385.701,1711.295,2384.538,1711.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2384.538,1722.963H2230.08c-1.164,0-2.107,0.943-2.107,2.106v4.003 c0,1.163,0.943,2.106,2.107,2.106h154.458c1.163,0,2.106-0.943,2.106-2.106v-4.003 C2386.645,1723.906,2385.701,1722.963,2384.538,1722.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2384.538,1734.63H2230.08c-1.164,0-2.107,0.943-2.107,2.106v4.003 c0,1.163,0.943,2.106,2.107,2.106h154.458c1.163,0,2.106-0.943,2.106-2.106v-4.003 C2386.645,1735.573,2385.701,1734.63,2384.538,1734.63z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2387.417,1761.494H2227.2v-0.645c0-3.146,2.55-5.696,5.696-5.696h148.824 c3.146,0,5.696,2.55,5.696,5.696V1761.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31535B"
    },
    d: "M2387.529,1760.665h-160.767c-0.714,0-1.292,0.578-1.292,1.292v0.293 c0,0.713,0.578,1.292,1.292,1.292h160.767c0.714,0,1.292-0.579,1.292-1.292v-0.293 C2388.821,1761.243,2388.243,1760.665,2387.529,1760.665z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2232.051,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2380.795,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.09,
    height: 40.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1084.646,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.773,
    height: 41.324
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1221.485,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.773,
    height: 41.324
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1231.682,1711.295h-154.458c-1.164,0-2.106,0.943-2.106,2.107v4.002 c0,1.164,0.943,2.106,2.106,2.106h154.458c1.164,0,2.106-0.942,2.106-2.106v-4.002 C1233.788,1712.238,1232.845,1711.295,1231.682,1711.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1231.682,1722.963h-154.458c-1.164,0-2.106,0.943-2.106,2.106v4.003 c0,1.163,0.943,2.106,2.106,2.106h154.458c1.164,0,2.106-0.943,2.106-2.106v-4.003 C1233.788,1723.906,1232.845,1722.963,1231.682,1722.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1231.682,1734.63h-154.458c-1.164,0-2.106,0.943-2.106,2.106v4.003 c0,1.163,0.943,2.106,2.106,2.106h154.458c1.164,0,2.106-0.943,2.106-2.106v-4.003 C1233.788,1735.573,1232.845,1734.63,1231.682,1734.63z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1234.561,1761.494h-160.216v-0.645c0-3.146,2.55-5.696,5.696-5.696h148.825 c3.146,0,5.696,2.55,5.696,5.696V1761.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31535B"
    },
    d: "M1234.673,1760.665h-160.767c-0.713,0-1.292,0.578-1.292,1.292v0.293 c0,0.713,0.579,1.292,1.292,1.292h160.767c0.714,0,1.292-0.579,1.292-1.292v-0.293 C1235.965,1761.243,1235.387,1760.665,1234.673,1760.665z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079.194,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1227.938,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 864.85,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.773,
    height: 41.324
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1001.689,
    y: 1717,
    style: {
      fill: "#31535B"
    },
    width: 2.773,
    height: 41.324
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1011.885,1711.295H857.427c-1.164,0-2.106,0.943-2.106,2.107v4.002 c0,1.164,0.943,2.106,2.106,2.106h154.458c1.163,0,2.107-0.942,2.107-2.106v-4.002 C1013.992,1712.238,1013.048,1711.295,1011.885,1711.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1011.885,1722.963H857.427c-1.164,0-2.106,0.943-2.106,2.106v4.003 c0,1.163,0.943,2.106,2.106,2.106h154.458c1.163,0,2.107-0.943,2.107-2.106v-4.003 C1013.992,1723.906,1013.048,1722.963,1011.885,1722.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1011.885,1734.63H857.427c-1.164,0-2.106,0.943-2.106,2.106v4.003 c0,1.163,0.943,2.106,2.106,2.106h154.458c1.163,0,2.107-0.943,2.107-2.106v-4.003 C1013.992,1735.573,1013.048,1734.63,1011.885,1734.63z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1014.764,1761.494H854.547v-0.645c0-3.146,2.55-5.696,5.696-5.696h148.825 c3.146,0,5.696,2.55,5.696,5.696V1761.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31535B"
    },
    d: "M1014.876,1760.665H854.11c-0.713,0-1.292,0.578-1.292,1.292v0.293 c0,0.713,0.579,1.292,1.292,1.292h160.767c0.713,0,1.292-0.579,1.292-1.292v-0.293 C1016.168,1761.243,1015.59,1760.665,1014.876,1760.665z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 859.398,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.142,
    y: 1763.542,
    style: {
      fill: "#31535B"
    },
    width: 3.091,
    height: 40.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1476.979,1750.543c0.374-1.041,6.642-20.508,6.642-20.508l-9.645,2.148l-4.393,15.126 c-0.375,0.756-7.162,19.053-9.519,24.95c-0.474,1.185-1.515,2.035-2.763,2.299c-0.006,0.001-0.013,0.003-0.02,0.004 c-0.836,0.18-2.458,0.751-2.8,0.983c-0.398,0.271-1.199,0.856-1.677,1.215c-0.478,0.358-1.053,0.76-1.283,0.979 c-0.14,0.134-0.543,0.293-0.837,0.396c-0.438,0.154-0.46,0.771-0.031,0.951c0.404,0.17,1.001-0.022,1.373-0.144 c1.047-0.343,2.41-1.445,2.455-1.284c0.045,0.161-1.513,2.692-1.672,2.993s-1.955,3.253-2.113,3.941 c-0.158,0.688,0.243,0.901,0.588,0.685c0.297-0.186,3.078-4.081,3.078-4.081s0.356-0.496,0.431-0.178 c0.076,0.318-2.443,3.859-2.72,4.458c-0.277,0.598-0.18,1.128,0.424,0.98c0.735-0.179,3.19-4.125,3.19-4.125 s0.316-0.488,0.466-0.286c0.15,0.202-2.043,3.18-2.109,3.546s0.224,0.771,0.747,0.522c0.616-0.292,2.777-3.833,2.777-3.833 s0.24-0.223,0.285-0.04c0.044,0.183-1.644,2.854-1.595,3.28c0.041,0.358,0.363,0.328,0.363,0.328 c0.701,0.084,1.983-2.74,2.961-3.847S1476.565,1751.695,1476.979,1750.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1516.253,1854.293c0,0,2.063,2.013,2.109,2.752c0.047,0.738,0.183,8.651-0.66,9.391 c-0.842,0.738-3.315,1.262-2.52,2.093c0.601,0.628,5.225,0.494,8.29,0.325c0.895-0.049,2.016-7.187,2.37-8.235 c0.515-1.523,1.767-4.955,1.298-6.018c-0.228-0.518-1.318-1.581-2.855-2.573c-1.616-1.044-3.163-3.368-3.163-3.368 L1516.253,1854.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1494.886,1858.98c0,0,1.846,5.214,1.848,5.228c0.138,0.826,0.678,2.867,0.678,3.618 c0,2.822-12.724-2.395-9.873-3.646c0.258-0.113,1.068-1.017,1.153-1.978c0.131-1.479-1.072-3.335-1.072-3.335L1494.886,1858.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1474.924,1761.876c0,0-0.928,9.349-0.928,9.487c0,15.123-2.998,44.661-2.427,47.505 c1.391,6.935,16.359,42.31,16.359,42.31l8.09-0.967l-10.542-42.354l3.879-17.048l5.49-33.698L1474.924,1761.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M1502.075,1770.145l1.535,8.86l4.153,36.465l15.817,35.64c0,0-2.225,5.186-5.507,5.914 l-25.174-36.591l-15.637-46.82l0.549-10.402L1502.075,1770.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1471.698,1739.618l11.218,1.145c0,0,0.515-9.196,0.515-13.583c0-5.322-0.453-12.178-1.096-12.03 c-1.804,0.414-4.233,1.41-5.68,3.397C1471.649,1725.424,1471.698,1739.618,1471.698,1739.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1477.208,1726.241c-0.235,1.622-4.547,45.737-4.547,45.737 c20.426,9.865,31.696,1.758,31.696,1.758s-0.668-30.979,0.133-35.195c0.53-2.789,1.191-21.326-0.617-21.846 c-2.32-0.666-4.98-1.374-7.879-1.675c-2.475-0.257-12.089-0.405-13.809,0.172 C1482.186,1715.192,1478.197,1719.417,1477.208,1726.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1524.186,1851.978c0,0-4.754,13.386-6.615,14.032c-0.494,0.171-2.865,0.606-3.313,1.655 c-0.135,0.315,0,1.37,0,1.37h9.909c0,0,1.253-5.897,1.749-8.488c0,0,2.623-6.332,2.332-6.907 S1524.186,1851.978,1524.186,1851.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1498.135,1868.758l-1.458-4.604c0,0-3.06,1.295-4.59,1.079c-1.53-0.216-4.518-1.079-4.518-1.079 c-6.107,2.01-11.111,2.986-10.201,4.604l0,0H1498.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1493.279,1705.962l1.503,9.188c0,0-5.501,11.69-8.788,10.706 c-2.758-0.826-1.062-10.866-1.062-10.866s1.503-5.393,1.053-8.091C1485.534,1704.201,1493.279,1705.962,1493.279,1705.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1485.985,1706.899c-0.451-2.698,7.294-0.938,7.294-0.938l0.125,0.791 c-0.227,0.528-0.504,0.981-0.84,1.328c-1.73,1.785-4.434,2.858-6.772,2.939 C1486.026,1709.565,1486.17,1708.006,1485.985,1706.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1494.55,1692.479c0.219-0.076,1.755,10.854-1.16,13.862c-2.914,3.008-8.592,3.991-10.629,1.623 c-2.252-2.62-2.139-14.368,2.392-17.462S1494.55,1692.479,1494.55,1692.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2E35"
    },
    d: "M1493.482,1688.268c1.59,0.18,3.751,1.023,5.983,4.567c2.744,4.357,0.717,9.186-2.477,11.555 c-3.194,2.368-3.138,5.081-3.138,5.081l-0.518-1.392c-0.373-1.072-0.525-2.209-0.4-3.334c0.075-0.675,0.226-1.404,0.517-2.004 c0.768-1.582-1.651-2.633-2.329-3.949c-0.522-1.014-0.548-3.332-1.371-5.007l-0.983-1.279c0,0-2.267-1.691-4.484-1.214 S1484.79,1681.392,1493.482,1688.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1491.27,1700.737c-0.023,1.333,0.609,2.425,1.412,2.438c0.803,0.013,1.473-1.058,1.496-2.391 c0.023-1.334-0.609-2.426-1.412-2.438C1491.963,1698.333,1491.293,1699.403,1491.27,1700.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1516.611,1735.163l-8.063,5.847l5.61,8.885c-4.475,4.472-15.23,11.635-15.23,11.635 s-1.001,0.688-2.352,1.469c-0.32,0.186-0.674,0.39-1.036,0.599c-0.634-0.017-1.603-0.022-2.183,0.176 c-0.784,0.269-2.268,0.388-2.6,0.627c-0.332,0.239-1.675,2.035-1.91,2.204c-0.234,0.168-0.381,0.541-0.481,0.731 c-0.1,0.19-1.734,1.337-1.939,1.751c-0.205,0.414,0.333,1.449,0.705,1.596c0,0,0.073,0.081-0.014,0.3 c-0.087,0.218-0.012,0.786,0.182,1.024c0.194,0.238,0.694,0.5,1.041,0.272c0,0,0.192-0.071,0.25-0.023 c0.057,0.048,0.167,0.479,0.447,0.744c0.28,0.266,0.687,0.306,1.245-0.029c0,0,0.349,1.433,1.529,0.714l1.607-0.979 c0,0,0.997-0.303,1.367-0.569c0.371-0.267,2.71-1.832,2.83-2.036c0.119-0.205,0.389-0.695,0.486-0.766s1.15-1.035,1.27-1.239 c0.074-0.127,0.863-0.802,1.455-1.299c0.749-0.347,1.535-0.714,2.352-1.098h0.001l0,0c11.325-5.328,22.405-10.223,21.822-14.326 C1524.683,1749.133,1519.233,1738.821,1516.611,1735.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1518.454,1735.412l-9.718,6.524c0,0-5.478-8.15-8.417-11.052 c-3.683-3.636,1.342-14.771,3.715-14.141C1509.341,1718.153,1518.454,1735.412,1518.454,1735.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1482.703,1703.251l4.815,0.49c0,0-0.297,1.817-2.42,1.663 C1482.508,1705.217,1482.703,1703.251,1482.703,1703.251z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1414.057,1852.054c0,0-0.638,6.972-0.219,9.245c0.057,0.305,0.18,0.689,0.324,1.114 c0.433,1.274-0.752,5.167-0.752,5.167l-15.886,0.059c-0.865,0.003-0.287-0.546,0.417-1.049c1.152-0.824,2.08-1.366,5.75-3.082 c0.239-0.111,1.112-0.65,1.427-0.837c0.798-0.474,1.603-1.223,2.297-1.976c1.156-1.253,1.332-7.396,1.332-7.396 L1414.057,1852.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1405.12,1862.669c4.187,1.128,7.301,0.436,9.047-0.242c0.432,1.272,1.245,5.575,0.76,5.575 c-3.984,0-7.355,0.754-18.77,0.574c-0.409-0.007-0.359-1.41-0.092-1.72C1396.802,1866,1404.805,1862.856,1405.12,1862.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1433.98,1769.3c0,0-0.226,9.95-3.078,16.323c-2.778,6.207-16.071,21.514-19.604,30.448 c1.092,5.039,4.094,12.122,3.877,17.708c-0.246,6.33,0.122,23.078,0.122,23.078l-7.134,0.226l-9.358-43.22l14.103-46.633 l6.399-11.324L1433.98,1769.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1464.458,1842.143c0,0,4.383,6.015,6.314,7.536c1.034,0.813,3.842,1.907,4.138,3.254 s-12.717,13.259-12.717,13.259c-0.688,0.609-0.612-0.234-0.403-1.131c0.342-1.466,0.703-2.551,2.429-6.496 c0.113-0.257,0.431-1.301,0.552-1.67c0.305-0.938,0.422-2.102,0.448-3.189c0.043-1.812-4.128-6.842-4.128-6.842 L1464.458,1842.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M1464.771,1856.892c4.136-2.038,6.136-4.776,7.055-6.543c1.238,0.713,4.569,2.232,4.276,2.657 c-2.302,3.34-4.69,7.493-13.931,15.36c-0.331,0.282-1.687-1.342-1.692-1.776 C1460.467,1865.391,1464.651,1857.263,1464.771,1856.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1433.478,1762.927c0,0,5.516,8.286,6.829,15.143c1.279,6.679-0.847,26.84,1.375,36.188 c3.783,3.505,10.301,7.59,13.323,12.293c3.425,5.329,13.321,18.845,13.321,18.845l-5.717,4.272l-32.431-30.063l-13.129-40.107 l-3.592-13.426L1433.478,1762.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M1417.043,1749.927c0.215-1.114,3.503-21.859,3.503-21.859l-9.448,3.703l-2.07,16.042 c-0.261,0.827-4.261,20.466-5.722,26.822c-0.293,1.276-1.216,2.304-2.441,2.769c-0.007,0.002-0.013,0.005-0.02,0.007 c-0.82,0.314-2.376,1.149-2.687,1.44c-0.361,0.338-1.082,1.058-1.511,1.497c-0.428,0.439-0.948,0.937-1.147,1.196 c-0.121,0.158-0.505,0.383-0.787,0.534c-0.42,0.227-0.345,0.855,0.118,0.971c0.437,0.108,1.013-0.182,1.37-0.362 c1.008-0.513,2.218-1.847,2.289-1.69s-1.11,2.971-1.225,3.301c-0.114,0.331-1.47,3.61-1.521,4.333 c-0.052,0.724,0.389,0.876,0.704,0.603c0.272-0.236,2.479-4.627,2.479-4.627s0.283-0.56,0.41-0.249s-1.87,4.302-2.057,4.953 c-0.187,0.65-0.005,1.173,0.585,0.929c0.717-0.298,2.585-4.689,2.585-4.689s0.244-0.546,0.428-0.364 c0.185,0.182-1.571,3.549-1.58,3.931c-0.009,0.382,0.348,0.747,0.84,0.412c0.58-0.394,2.214-4.328,2.214-4.328 s0.208-0.264,0.283-0.085c0.074,0.178-1.218,3.155-1.101,3.581c0.098,0.357,0.42,0.274,0.42,0.274 c0.725-0.025,1.58-3.094,2.398-4.37C1405.174,1783.322,1416.805,1751.162,1417.043,1749.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2E35"
    },
    d: "M1413.083,1707.736c-0.191-4.613,0.486-9.169,2.541-13.464c1.768-3.695,6.143-5.792,10.133-5.797 c12.669-0.017,14.28,16.794,22.345,23.278c2.464,1.981,5.218,3.596,7.55,5.732c8.61,7.89,4.731,22.495-3.174,29.412 c-5.486,4.8-14.109,7.527-20.871,3.775c-3.53-1.959-6.209-5.215-8.118-8.782c-2.709-5.063-4.456-10.905-6.383-16.302 C1415.056,1719.847,1413.337,1713.867,1413.083,1707.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M1453.166,1777.387c0.024-0.104-4.186-17.98-5.887-21.934c-1.702-3.953-8.315-22.312-8.315-22.312 l8.56-1.87c0,0,5.52,14.367,8.037,20.862c2.517,6.495,1.441,18.472,1.554,21.851c0.001,0.049,0.37,2.858,0.372,2.906h0 c0.086,0.373,0.166,0.686,0.203,0.746c0.102,0.165,0.396,1.299,0.409,1.396s0.264,0.481,0.366,0.646s0.334,2.461,0.385,2.832 c0.05,0.371-0.114,1.209-0.114,1.209l0.09,1.539c0.066,1.131-1.105,0.832-1.105,0.832c0.027,0.533-0.158,0.813-0.458,0.912 c-0.3,0.101-0.654,0.015-0.711,0.037c-0.057,0.023-0.079,0.19-0.079,0.19c0.031,0.339-0.351,0.6-0.598,0.647 c-0.247,0.049-0.688-0.115-0.812-0.262c-0.125-0.147-0.211-0.126-0.211-0.126c-0.25,0.213-1.206,0.204-1.427-0.104 s-0.422-1.932-0.521-2.078c-0.1-0.146-0.313-0.395-0.344-0.629s-0.815-1.898-0.86-2.23c-0.045-0.332,0.439-1.452,0.547-2.123 c0.108-0.671,0.762-1.715,0.92-2.015C1453.226,1778.193,1453.21,1777.811,1453.166,1777.387L1453.166,1777.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1411.014,1730.074c3.957-12.004,8.382-11.492,8.382-11.492l-3.422,25.236 c-2.443-0.668-5.625-2.155-8.066-2.845C1408.717,1737.179,1410.04,1733.03,1411.014,1730.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M1429.523,1716.427c0,0,7.291-0.466,10.176,2.686c2.884,3.151-6.399,28.077-6.923,32.088 c-0.525,4.01,2.674,14.673,2.674,14.673s-17.127,3.455-22.022,0.208c0,0-0.524-28.838,0-31.702 c0.525-2.865,4.895-14.515,5.944-15.661C1420.42,1717.572,1429.523,1716.427,1429.523,1716.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1427.097,1706.662c0,0,0.038,0.215,0.105,0.581c0.325,1.757,1.577,7.585,2.422,9.188 c1.022,1.937-3.499,8.111-7.85,7.358c-1.295-0.225,1.095-5.675,0.98-6.252c-0.22-1.104-0.518-2.612-0.823-4.158 c-0.172-0.872-0.347-1.756-0.51-2.587c-0.465-2.361-0.845-4.293-0.845-4.293L1427.097,1706.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1427.202,1707.243c-0.068-0.366-0.105-0.581-0.105-0.581l-6.521-0.163 c0,0,0.38,1.932,0.845,4.293c0.163,0.826,0.336,1.705,0.507,2.572c1.006-0.148,2.059-0.639,3.113-1.564 c1.15-1.009,1.904-2.221,2.358-3.515C1427.319,1707.872,1427.252,1707.516,1427.202,1707.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1422.708,1691.809c0,0,3.073-0.356,5,2.141s4.002,10.22-0.783,14.418s-9.514-0.554-10.214-5.593 C1416.009,1697.735,1415.737,1691.626,1422.708,1691.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1415.294,1702.7c0.571,1.113,1.53,1.729,2.142,1.376c0.612-0.353,0.644-1.541,0.073-2.653 c-0.571-1.113-1.53-1.729-2.142-1.377C1414.756,1700.399,1414.724,1701.587,1415.294,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2E35"
    },
    d: "M1422.364,1690.982c0,0,4.106,7.344,7.043,7.683c2.937,0.34,3.323,4.242,3.323,4.242 s-1.05-8.992-3.958-10.726C1425.864,1690.447,1422.364,1690.982,1422.364,1690.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1425.759,1704.059l-6.142,0.242c0,0,0.233,2.328,2.938,2.299 C1425.853,1706.564,1425.759,1704.059,1425.759,1704.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M1442.304,1743.875c0,0-9.452-11.31-11.159-15.494c-1.707-4.186,0.847-10.453,4.833-10.944 c3.986-0.492,13.96,18.069,13.96,18.069L1442.304,1743.875z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2385.34,1693.729c-0.123-0.729,3.313-0.716,3.609-1.381s-4.093-1.466-4.146-2.104 c-0.1-1.175,4.86,0.581,4.85,0.038c-0.012-0.543-5.037-2.605-4.319-3.413c0.718-0.807,4.988,2.683,5.235,2.094 c0.247-0.588-4.264-2.888-3.949-4.216c0.167-0.71,7.209,4.907,8.178,4.67c0.967-0.237-0.331-3.93,0.472-4.309 s1.806,6.866,2.26,7.195c0.452,0.329,10.49,6.694,14.064,8.281c0.666-1.175,5.401-7.339,6.003-8.454 c1.843,1.848,5.046,1.133,6.979,2.86c-2.234,3.662-8.742,14.625-9.918,14.933c-3.58,0.938-17.071-10.706-19.328-12.967 c-2.259-2.263-3.83-1.92-5.469-2.792C2388.22,1693.293,2385.463,1694.456,2385.34,1693.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M2415.354,1694.234c0,0,5.062-13.638,8.235-16.83s9.972-3.174,12.02,0.383 c2.047,3.557-11.066,19.974-11.066,19.974L2415.354,1694.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2433.173,1685.13c-5.148-0.113-4.568-10.067-4.568-10.067c-0.464,0.04-0.847,0.09-1.122,0.15 c0.275-0.061,0.658-0.11,1.121-0.15c1.97-0.171,3.554-1.68,3.872-3.63c0.232-1.427,0.391-2.99,0.219-4.065 c-0.391-2.446,6.322-0.85,6.322-0.85l0.88,5.816c0.255,1.69,1.524,3.047,3.193,3.416 C2443.09,1675.75,2438.322,1685.242,2433.173,1685.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M2457.871,1800.756c0,0,1.855,1.815,1.897,2.481c0.042,0.667,0.164,7.805-0.593,8.471 c-0.758,0.667-2.98,1.14-2.266,1.889c0.54,0.566,4.696,0.445,7.452,0.294c0.804-0.045,1.813-6.483,2.131-7.43 c0.463-1.374,1.588-4.47,1.167-5.428c-0.205-0.467-1.186-1.426-2.566-2.321c-1.453-0.942-2.844-3.038-2.844-3.038 L2457.871,1800.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2438.662,1804.983c0,0,1.659,4.704,1.661,4.716c0.124,0.746,0.609,2.587,0.609,3.265 c0,2.545-11.439-2.161-8.876-3.289c0.232-0.102,0.96-0.917,1.037-1.783c0.117-1.335-0.964-3.009-0.964-3.009L2438.662,1804.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M2420.716,1717.389c0,0-2.034,8.18-2.034,8.305c0,13.642-1.494,40.541-0.982,43.105 c1.251,6.256,14.707,38.167,14.707,38.167l7.273-0.872l-5.033-34.225l6.937-23.567l-2.958-26.191L2420.716,1717.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2455.656,1723.477l-2.842,30.848l11.644,43.56c0,0-2,4.678-4.95,5.335l-22.631-33.008 l-14.059-42.236l0.493-9.383L2455.656,1723.477z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2465.004,1798.667c0,0-4.274,12.074-5.947,12.657c-0.444,0.155-2.576,0.548-2.979,1.493 c-0.121,0.285,0,1.237,0,1.237h8.909c0,0,1.127-5.32,1.571-7.658c0,0,2.358-5.711,2.097-6.23 C2468.393,1799.647,2465.004,1798.667,2465.004,1798.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2441.583,1813.804l-1.31-4.152c0,0-2.751,1.167-4.127,0.973s-4.062-0.973-4.062-0.973 c-5.491,1.813-9.988,2.693-9.171,4.152l0,0H2441.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#F47458"
    },
    d: "M2432.694,1667.367c-0.391-2.446,6.322-0.85,6.322-0.85l0.108,0.717 c-0.196,0.479-0.437,0.89-0.728,1.205c-1.5,1.619-3.844,2.591-5.87,2.665C2432.73,1669.785,2432.854,1668.371,2432.694,1667.367z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2440.118,1654.291c0.189-0.069,1.735,10.89-0.79,13.617s-8.197,2.795-9.963,0.646 c-1.952-2.376-1.319-13.25,2.607-16.056C2435.9,1649.693,2440.118,1654.291,2440.118,1654.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2433.468,1647.196c3.036,0.621,5.002,2.482,5.725,3.275c1.378,0.163,3.251,0.928,5.186,4.142 c2.379,3.952,0.622,8.33-2.146,10.478c-2.769,2.148-2.73,4.63-2.73,4.63l-0.438-1.283c-0.323-0.973-0.455-2.004-0.347-3.023 c0.064-0.611,0.195-1.273,0.447-1.817c0.666-1.435-1.431-2.388-2.019-3.581c-0.452-0.919-0.475-3.021-1.188-4.541l-0.852-1.159 c0,0-1.965-1.534-3.888-1.102C2429.297,1653.647,2429.573,1646.399,2433.468,1647.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2437.275,1661.779c-0.021,1.209,0.527,2.199,1.224,2.212c0.696,0.012,1.276-0.959,1.296-2.169 c0.021-1.209-0.527-2.199-1.224-2.211S2437.295,1660.57,2437.275,1661.779z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2433.037,1665.291l-3.451-0.253c0,0-0.017,1.32,1.498,1.477 C2432.93,1666.704,2433.037,1665.291,2433.037,1665.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#327F6B"
    },
    d: "M2424.556,1679.429c1.273-2.646,2.688-4.152,2.688-4.152c0.267-0.09,0.742-0.16,1.36-0.214 c0,0-0.58,9.954,4.568,10.067c5.149,0.112,9.917-9.38,9.917-9.38c1.301,0.287,2.76,0.625,3.652,0.882c0,0,4.5,0.854,5.723,7.588 c1.223,6.732,3.491,32.047,3.666,37.284c0.127,3.813-5.697,7.143-13.789,8.612c-1.939,0.51-4.449,0.884-7.497,0.776 c-0.765,0.023-1.538,0.031-2.317,0.021c-8.973-0.107-12.172-2.654-13.281-4.15c-0.188-0.089-0.373-0.169-0.564-0.262 c0,0,0.021-0.222,0.061-0.622c-0.044-0.117-0.061-0.187-0.061-0.187S2412.105,1700.881,2424.556,1679.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2445.254,1691.921c0,0,11.022,15.521,13.628,19.135c2.605,3.612,9.778,18.097,10.039,18.669 c0.261,0.571-3.591,7.714-2.595,7.914c0.997,0.199,1.781-3.756,2.86-3.33s4.847,9.723,5.406,9.231 c1.046-0.918-2.089-5.777-1.52-6.113c0.569-0.337,2.808,5.371,3.96,5.154s-2.62-5.209-2.329-5.675 c0.292-0.466,4.17,4.226,4.727,3.17c0.302-0.573-3.549-4.088-2.89-4.458c0.66-0.37,4.018,1.864,4.303,1.17 s-3.062-1.496-4.181-3.292c-1.12-1.797-2.849-2.524-3.8-5.896c-0.952-3.371-3.234-17.63-7.25-23.625s-12.213-17.253-12.213-17.253 L2445.254,1691.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M2463.058,1697.616l-10.733,7.23c0,0-6.05-9.032-9.297-12.248 c-4.068-4.028,1.481-16.369,4.103-15.671C2452.992,1678.489,2463.058,1697.616,2463.058,1697.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1788.573,1735.003l0.563,0.506c0.29,0.261,0.727,0.25,0.975-0.024l10.002-11.032 c0.248-0.273,0.214-0.707-0.076-0.967l-0.563-0.507c-0.291-0.26-0.727-0.249-0.975,0.024l-10.002,11.032 C1788.25,1734.31,1788.283,1734.742,1788.573,1735.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1754.665,1726.04c1.337-1.091,11.675,3.461,11.544,5.046c-0.132,1.584,7.214,16.945,7.214,16.945 l12.692-10.155l0.005,0.003c0.112-0.367,1.315-4.316,1.374-5.023c0.061-0.741,2.206-2.038,3.203-1.847 c0.995,0.19-0.853,1.444-0.974,1.675c-0.33,0.627,0.946,0.861,0.946,0.861s3.668-2.02,3.746-3.207 c0.077-1.188,0.834-3.678,1.627-3.156c0.408,0.269,0.405,2.035,0.277,2.873c0.235-0.951,0.569-2.025,0.894-2.133 c0.594-0.193,0.889,0.563,0.781,0.936c-0.108,0.371-1.066,4.41-1.357,4.865c-0.284,0.443-6.207,5.231-7.061,6.271 c0,0-16.417,18.831-17.586,19.324c-1.025,0.432-4.683-6.058-8.138-10.366S1750.487,1729.448,1754.665,1726.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M1721.539,1864.513c0,0-2.257,2.209-2.307,3.02c-0.052,0.811-0.2,9.494,0.721,10.305 c0.921,0.812,3.627,1.386,2.757,2.298c-0.657,0.689-5.715,0.542-9.066,0.356c-0.979-0.054-2.205-7.887-2.593-9.038 c-0.563-1.672-1.931-5.438-1.419-6.603c0.249-0.568,1.441-1.735,3.122-2.824c1.768-1.146,3.459-3.696,3.459-3.696 L1721.539,1864.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1744.908,1869.656c0,0-2.019,5.723-2.021,5.737c-0.149,0.906-0.74,3.146-0.74,3.971 c0,3.097,13.916-2.628,10.798-4.001c-0.282-0.124-1.168-1.116-1.261-2.17c-0.144-1.623,1.172-3.66,1.172-3.66L1744.908,1869.656z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M1766.74,1763.092c0,0,1.015,10.259,1.015,10.412c0,16.595,3.278,49.012,2.655,52.132 c-1.521,7.61-17.892,46.432-17.892,46.432l-8.849-1.061l11.53-46.48l-4.243-18.709l-6.004-36.981L1766.74,1763.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1737.045,1772.166l-1.679,9.723l-4.542,40.019l-17.299,39.111c0,0,2.433,5.691,6.023,6.49 l27.532-40.155l17.103-51.383l-0.601-11.415L1737.045,1772.166z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E25A44"
    },
    d: "M1770.27,1738.665l-12.27,1.257c0,0-0.563-10.093-0.563-14.907c0-5.841,0.496-13.364,1.198-13.202 c1.974,0.455,4.63,1.548,6.212,3.729C1770.322,1723.088,1770.27,1738.665,1770.27,1738.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1764.242,1723.984c0.257,1.781,4.973,50.194,4.973,50.194 c-22.339,10.826-34.666,1.929-34.666,1.929s0.73-33.997-0.146-38.624c-0.579-3.062-1.302-23.405,0.675-23.975 c2.537-0.731,5.446-1.508,8.617-1.838c2.707-0.282,13.222-0.445,15.103,0.188 C1758.798,1711.859,1763.161,1716.496,1764.242,1723.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1712.862,1861.971c0,0,5.2,14.69,7.235,15.399c0.54,0.188,3.133,0.666,3.622,1.816 c0.147,0.347,0,1.505,0,1.505h-10.837c0,0-1.371-6.473-1.913-9.316c0,0-2.869-6.948-2.55-7.58 C1708.738,1863.164,1712.862,1861.971,1712.862,1861.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1741.354,1880.386l1.594-5.052c0,0,3.347,1.421,5.021,1.185c1.674-0.237,4.94-1.185,4.94-1.185 c6.68,2.206,12.152,3.277,11.157,5.052l0,0H1741.354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1771.991,1759.318c0.051-0.021,0.231-0.165,0.337-0.251c-0.398-4.743-0.326-9.339,1.158-10.894 c-0.036-0.074-0.36-0.766-0.699-1.482c-1.719,1.334-2.536,4.879-2.215,10.633c0.021,0.396,0.135,0.698,0.227,1.191 C1771.297,1759.065,1771.749,1759.42,1771.991,1759.318z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M1712.423,1774.691c-0.014-0.104-0.016-0.208-0.005-0.312c0.329-3.353,3.104-31.507,3.57-32.703 c0.422-1.081,12.864-18.938,12.864-18.938l6.116,8.36l-11.967,16.016c-0.268,1.019-4.585,20.023-4.585,20.023 s-0.886,3.464-1.282,5.539c0.182,0.5,0.358,0.973,0.516,1.359c0.396,0.828,0.864,1.508,1.289,2.08 c0.535,0.719,1.42,2.291,1.528,2.711c0.127,0.489,0.355,1.505,0.484,2.118c0.13,0.613,0.307,1.327,0.337,1.66 c0.018,0.203,0.227,0.606,0.387,0.893c0.238,0.425-0.169,0.927-0.631,0.772c-0.435-0.145-0.772-0.709-0.981-1.062 c-0.589-0.993-0.903-2.807-1.05-2.711c-0.146,0.097-0.662,3.173-0.743,3.521c-0.082,0.349-0.701,3.921-1.05,4.574 c-0.35,0.652-0.812,0.543-0.935,0.135c-0.106-0.353,0.386-5.352,0.386-5.352s0.062-0.637-0.217-0.438s-0.733,4.736-0.927,5.4 c-0.194,0.664-0.635,1.016-1.01,0.482c-0.455-0.649,0.328-5.462,0.328-5.462s0.088-0.605-0.17-0.549 c-0.258,0.056-0.58,3.923-0.78,4.258c-0.201,0.335-0.707,0.454-0.948-0.103c-0.284-0.657,0.452-4.948,0.452-4.948 s-0.036-0.341-0.197-0.228c-0.16,0.113-0.671,3.391-1.003,3.693c-0.279,0.255-0.512,0.008-0.512,0.008 c-0.609-0.418,0.325-3.535,0.315-5.085c-0.009-1.55,0.708-3.291,0.494-5.137 C1712.484,1775.154,1712.447,1774.87,1712.423,1774.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1719.132,1734.049l10.629,7.16c0,0,5.99-8.944,9.206-12.129 c4.028-3.989-1.468-16.209-4.063-15.518C1729.099,1715.108,1719.132,1734.049,1719.132,1734.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1744.476,1701.204l-1.59,10.515c0,0,5.806,12.519,9.272,11.433 c2.907-0.911,1.118-11.988,1.118-11.988s-1.585-5.948-1.109-8.925S1744.476,1701.204,1744.476,1701.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1752.168,1702.238c0.476-2.977-7.692-1.034-7.692-1.034l-0.132,0.872 c0.239,0.583,0.531,1.083,0.886,1.466c1.824,1.97,4.676,3.152,7.141,3.242C1752.125,1705.179,1751.973,1703.459,1752.168,1702.238 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1743.137,1686.33c-0.23-0.084-1.85,11.975,1.223,15.293c3.073,3.317,9.061,4.403,11.208,1.79 c2.375-2.891,2.256-15.851-2.521-19.264S1743.137,1686.33,1743.137,1686.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M1751.226,1677.699c-3.692,0.755-6.085,3.02-6.963,3.984c-1.677,0.199-3.956,1.129-6.31,5.038 c-2.894,4.808-0.757,10.134,2.612,12.747c3.368,2.613,3.321,5.632,3.321,5.632l0.532-1.562c0.394-1.183,0.554-2.437,0.422-3.678 c-0.078-0.744-0.237-1.549-0.545-2.211c-0.81-1.745,1.74-2.904,2.456-4.356c0.551-1.118,0.577-3.676,1.444-5.523l1.036-1.411 c0,0,2.391-1.866,4.729-1.34C1756.302,1685.547,1755.965,1676.729,1751.226,1677.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1746.596,1695.439c0.024,1.472-0.643,2.676-1.489,2.69s-1.552-1.166-1.577-2.638 c-0.023-1.471,0.643-2.676,1.489-2.689C1745.865,1692.788,1746.571,1693.969,1746.596,1695.439z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1751.586,1698.84l4.632-0.241c0,0-0.016,1.771-2.05,1.936 C1751.688,1700.735,1751.586,1698.84,1751.586,1698.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1870.69,1725.951c0,0,9.738,21.372,11.804,25.346c2.064,3.974,5.907,16.219,6.083,16.824 s-4.913,7.443-3.951,7.793c0.962,0.35,2.316-3.447,3.327-2.861c1.012,0.586,3.405,10.364,4.033,9.964 c1.173-0.75-1.237-6.038-0.622-6.284c0.615-0.247,2.01,5.745,3.187,5.706c1.178-0.039-1.847-5.556-1.489-5.973 c0.356-0.417,3.531,4.818,4.237,3.858c0.385-0.521-2.934-4.588-2.224-4.854s3.724,2.458,4.107,1.813 c0.384-0.644-2.827-1.947-3.679-3.896s-2.464-2.933-2.92-6.415c-0.457-3.482-0.636-15.92-3.757-22.467 c-3.121-6.548-9.979-21.032-9.979-21.032L1870.69,1725.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1873.787,1702.152c0.219-5.274-0.555-10.482-2.904-15.393c-2.022-4.225-7.023-6.622-11.585-6.628 c-14.484-0.019-16.327,19.201-25.547,26.614c-2.817,2.266-5.966,4.11-8.632,6.554c-9.845,9.021-5.41,25.719,3.629,33.627 c6.272,5.487,16.131,8.606,23.861,4.315c4.035-2.239,7.099-5.962,9.281-10.04c3.098-5.789,5.095-12.468,7.297-18.637 C1871.533,1715.998,1873.498,1709.162,1873.787,1702.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1822.028,1681.629c0.669-0.485,2.36,2.965,3.174,2.932s-0.562-4.828,0.051-5.198 c1.128-0.683,1.828,5.159,2.367,4.878c0.539-0.28,0.112-6.34,1.277-6.021s-0.214,6.329,0.499,6.285 c0.712-0.045,0.779-5.704,2.266-6.05c0.795-0.185-1.341,9.659-0.623,10.511c0.718,0.853,3.774-2.28,4.551-1.663 c0.777,0.616-5.984,5.215-6.089,5.833c-0.105,0.616-1.505,13.832-1.321,18.201c1.507,0.085,10.032,1.772,11.448,1.821 c-0.938,2.764,1.367,5.619,0.595,8.412c-4.777-0.422-18.99-1.506-19.883-2.531c-2.715-3.122,2.261-22.417,3.407-25.8 c1.146-3.387,0.024-4.79,0.085-6.865S1821.359,1682.113,1822.028,1681.629z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1844.179,1878.971c1.204-0.888,2.176-1.475,6.022-3.34c0.251-0.121,1.164-0.703,1.494-0.905 c0.835-0.511,1.674-1.315,2.396-2.121c0.689-0.77,1.018-3.235,1.173-5.201c-0.397-4.391-6.758-74.799-8.099-82.421 c-1.386-7.868,0.725-19.869,0.725-19.869l4.91-1.853l9.322,32.313l-0.734,24.597c0,0,2.192,7.09,2.469,11.326 c0.277,4.236-3.169,38.626-3.169,38.626l0,0c0,1.229,0.048,2.342,0.185,3.036c0.253,1.286,1.662,3.935,1.016,5.145 c-0.646,1.211-1.385,1.514-1.385,1.514l-16.752,0.271C1842.84,1880.102,1843.442,1879.513,1844.179,1878.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1869.603,1762.59c0,0,5.817,8.775,7.202,16.037c1.386,7.264-1.017,29.583,1.648,39.1 c1.442,5.152,6.908,13.108,7.739,19.766s3.723,25.873,3.723,25.873h-0.001c0.438,2.017,1.123,4.512,2.013,5.672 c0.545,0.71,1.539,1.607,2.192,2.891c1.016,1.998,0.454,4.972-0.296,6.609c-0.385,0.84,0.027,0.838-0.849,1.108 c-2.595,0.803-5.355-0.549-6.459-3.039c-0.617-1.392-1.159-3.247-1.268-5.586c-0.115-2.479-0.504-4.448-0.916-5.904l0,0 l-18.595-45.612l-13.461-39.364l-3.449-20.273L1869.603,1762.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1886.012,1875.297c4.024,0.735,6.702-1.625,8.096-3.391c1.023,2.001,1.521,4.986,0.77,6.631 c-0.662,1.447-2.6,1.406-4.124,1.463c-1.612,0.06-2.859-0.838-3.659-2.245C1886.72,1877.098,1886.335,1876.279,1886.012,1875.297 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1851.697,1874.725c4.431,1.139,7.705,0.364,9.537-0.376c0.473,1.342,1.099,3.026,0.767,3.997 c-0.406,1.188-0.985,1.457-1.497,1.471c-4.047,0.106-14.823,0.251-17.908,0.291c-0.432,0.006-0.669-0.498-0.393-0.83 C1842.969,1878.361,1851.367,1874.927,1851.697,1874.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1865.83,1818.644c-0.348,0.023-0.697,0.046-1.049,0.067c-0.019,0.001-0.036,0.002-0.055,0.003 c-0.345,0.021-0.691,0.04-1.039,0.059c-0.021,0.001-0.042,0.002-0.063,0.003c-0.349,0.019-0.697,0.035-1.048,0.05 c-0.018,0.001-0.035,0.001-0.054,0.002c-0.355,0.016-0.712,0.029-1.069,0.041c-3.971,0.13-8.875,0.079-12.023-0.455 c-1.604-16.062-2.202-30.72-2.796-33.964c-1.44-7.867,1.256-20.286,1.256-20.286l-0.218-2.948l0.69-1.882l21.604,2.724 c0,0,6.049,8.775,7.489,16.038s-1.058,29.582,1.714,39.1C1879.171,1817.194,1873.003,1818.155,1865.83,1818.644z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAB054"
    },
    d: "M1836.409,1711.956c0,0,16.175-1.692,20.948-0.095c4.773,1.597,8.127,8.417,5.578,12.233 c-2.548,3.815-25.504-1.182-25.504-1.182L1836.409,1711.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1864.938,1710.452c0,0,8.001-0.495,11.166,2.857c3.166,3.353-7.021,29.875-7.597,34.142 c-0.575,4.268,2.934,15.613,2.934,15.613s-18.795,3.676-24.167,0.221c0,0-0.987-30.98-0.412-34.029 c0.576-3.048,5.784-15.146,6.935-16.365C1854.947,1711.671,1864.938,1710.452,1864.938,1710.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1862.273,1700.063c0,0,0.042,0.229,0.116,0.618c0.356,1.87,1.73,8.07,2.658,9.775 c1.122,2.061-3.84,8.631-8.614,7.829c-1.422-0.238,1.201-6.037,1.075-6.651c-0.241-1.176-0.568-2.78-0.903-4.425 c-0.188-0.928-0.38-1.868-0.56-2.752c-0.511-2.513-0.928-4.568-0.928-4.568L1862.273,1700.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1862.39,1700.681c-0.074-0.39-0.116-0.618-0.116-0.618l-7.155-0.174c0,0,0.417,2.056,0.928,4.568 c0.179,0.879,0.368,1.814,0.557,2.736c1.104-0.158,2.259-0.68,3.416-1.664c1.263-1.073,2.089-2.363,2.588-3.74 C1862.519,1701.35,1862.445,1700.971,1862.39,1700.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1857.458,1684.258c0,0,3.372-0.379,5.486,2.277c2.114,2.657,4.393,10.874-0.858,15.342 c-5.252,4.467-10.44-0.59-11.21-5.951S1849.808,1684.063,1857.458,1684.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1849.322,1695.847c0.627,1.184,1.679,1.84,2.35,1.465c0.672-0.376,0.707-1.64,0.08-2.824 c-0.626-1.184-1.679-1.84-2.35-1.464C1848.731,1693.398,1848.695,1694.662,1849.322,1695.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M1857.081,1683.379c0,0,4.505,7.813,7.729,8.175s3.646,4.513,3.646,4.513 s-1.152-9.566-4.343-11.412C1860.922,1682.81,1857.081,1683.379,1857.081,1683.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M1863.965,1693.518c-0.263,1.387,0.265,2.66,1.177,2.842c0.913,0.182,1.865-0.795,2.128-2.183 c0.262-1.388-0.266-2.66-1.179-2.843C1865.179,1691.152,1864.226,1692.13,1863.965,1693.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1859.536,1697.129l-4.604,0.659c0,0,0.356,1.733,2.39,1.502 C1859.801,1699.008,1859.536,1697.129,1859.536,1697.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M1875.759,1741.066c0,0-9.038-13.521-9.851-18.488c-0.813-4.968,3.658-11.113,8.223-10.639 c4.563,0.476,12.364,23.098,12.364,23.098L1875.759,1741.066z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00213D"
    },
    d: "M1154.101,1738.104c0,0-22.172,2.175-24.045,3.081c-1.873,0.906-6.827,3.142-7.431,9.485 s16.936-0.121,17.923-0.483c0.987-0.362,13.674-7.189,13.553-7.491C1153.979,1742.393,1154.101,1738.104,1154.101,1738.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00213D"
    },
    d: "M1097.357,1738.104c0,0,22.172,2.175,24.045,3.081c1.873,0.906,9.871-2.831,10.476,3.513 c0.604,6.343-19.98,5.852-20.968,5.489c-0.987-0.362-13.674-7.189-13.553-7.491 C1097.478,1742.393,1097.357,1738.104,1097.357,1738.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001333"
    },
    d: "M1127.712,1755.485c0-0.533,0.42-0.98,0.953-0.994c0.513-0.014,1.101-0.095,1.403-0.366 c0.604-0.544,2.658-1.148,4.471-0.785c1.813,0.362,6.525-0.483,7.975,0.725c1.45,1.208,3.504,3.262,2.054,4.229 c-1.45,0.967-7.129,1.994-8.458,1.692c-1.069-0.243-5.678-0.591-7.509-0.723c-0.405-0.029-0.888-0.379-0.888-0.785V1755.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M1127.802,1755.074l-4.299-2.407l-0.732,4.929l5.797,1.664c0,0-0.104-3.293-0.225-3.474 C1128.222,1755.604,1127.802,1755.074,1127.802,1755.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#223C56"
    },
    d: "M1087.887,1743.42c0,0-0.846-4.168,1.329-5.316c2.175-1.147,6.766-0.967,10.995,0.967 s29.845,14.258,29.845,14.258s-1.571,4.531-2.719,5.921c0,0-22.958-6.646-28.213-8.156 C1093.867,1749.582,1089.396,1749.582,1087.887,1743.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001333"
    },
    d: "M1117.125,1755.701c0-0.533-0.42-0.98-0.953-0.994c-0.513-0.014-1.101-0.095-1.403-0.366 c-0.604-0.544-2.658-1.147-4.471-0.785s-6.525-0.483-7.975,0.725c-1.45,1.208-3.504,3.263-2.054,4.229 c1.45,0.967,7.128,1.993,8.458,1.691c1.069-0.243,5.677-0.591,7.509-0.723c0.405-0.029,0.888-0.379,0.888-0.785V1755.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M1117.036,1755.29l4.299-2.407l1.027,6.071l-6.092,0.522c0,0,0.104-3.293,0.224-3.475 C1116.616,1755.82,1117.036,1755.29,1117.036,1755.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#264160"
    },
    d: "M1161.551,1743.42c0,0,0.846-4.168-1.329-5.316c-2.175-1.147-6.767-0.967-10.995,0.967 c-4.229,1.934-29.845,14.258-29.845,14.258s1.57,4.531,2.719,5.921c0,0,22.957-6.646,28.213-8.156 C1155.57,1749.582,1160.041,1749.582,1161.551,1743.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1137.435,1706.519c0.505-4.774-2.216-9.182-6.696-10.486c-0.241-2.663-1.584-5.224-3.623-6.857 c-4.021-3.223-11.007-4.496-13.232,0.357c-3.354,2.329-5.717,6.877-4.264,10.655c-3.089,3.843-9.199,9.793-5.825,18.228 c0.317,3.929,3.079,5.427,6.748,6.748c0.881,0.317,12.371,3.937,12.191-2.633c-0.24-0.181,3.348,7.203,11.724,2.81 C1143.003,1720.856,1143.715,1710.601,1137.435,1706.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1085.102,1712.309c-0.057-0.6,2.737-0.383,3.017-0.905c0.281-0.523-3.239-1.438-3.245-1.959 c-0.01-0.961,3.917,0.765,3.94,0.322s-3.938-2.421-3.306-3.034s3.894,2.48,4.13,2.017s-3.292-2.604-2.958-3.665 c0.179-0.567,5.567,4.423,6.368,4.288s-0.033-3.215,0.643-3.475s0.871,6.056,1.22,6.352c0.348,0.294,8.089,7.013,10.9,8.517 c0.612-0.914,3.527-3.89,4.083-4.76c1.387,1.612,2.1,2.715,3.567,4.235c-2.036,2.844-5.865,8.164-6.84,8.344 c-2.967,0.548-11.894-11.077-13.593-13.051c-1.701-1.976-2.998-1.792-4.278-2.599 C1087.47,1712.128,1085.158,1712.908,1085.102,1712.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1159.597,1709.547c0.057-0.6-2.737-0.383-3.017-0.906c-0.281-0.522,3.239-1.438,3.245-1.959 c0.01-0.961-3.917,0.765-3.94,0.322c-0.023-0.442,3.938-2.421,3.306-3.034c-0.632-0.612-3.894,2.48-4.13,2.018 c-0.236-0.464,3.292-2.604,2.958-3.665c-0.179-0.567-5.567,4.422-6.368,4.287c-0.801-0.135,0.033-3.214-0.643-3.474 s-0.872,6.056-1.221,6.351c-0.348,0.295-8.089,7.013-10.899,8.518c-0.612-0.914-3.527-3.89-4.083-4.761 c-1.387,1.613-2.1,2.716-3.567,4.236c2.036,2.843,5.865,8.163,6.839,8.343c2.967,0.548,11.894-11.077,13.593-13.051 c1.7-1.976,2.998-1.791,4.278-2.599C1157.229,1709.366,1159.541,1710.146,1159.597,1709.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1138.186,1715.434l-4.813,5.756c0,0-4.831-4.035-7.16-5.294 c-2.918-1.578-1.819-9.331-0.246-9.368C1129.486,1706.443,1138.186,1715.434,1138.186,1715.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1113.438,1707.852c1.256-0.762,8.42-1.072,10.457-1.271c0.429-0.043,1.266-0.27,1.303-0.27 c1.026,0.343,4.674,1.297,6.852,5.862c2.638,5.516,1.369,8.968,1.04,15.347c-0.215,4.155,1.234,13.568,1.234,13.568 c-3.216,4.332-15.017,4.65-19.188,1.268l2.892-12.691c0.006-3.273-2.737-9.509-3.027-10.445 c-0.408,0.441-1.432,2.457-1.432,2.457c-1.927,0.01-6.715-4.88-6.715-4.88S1112.182,1708.613,1113.438,1707.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1120.209,1701.316c0,0,0.769,4.139,0.615,5.771s0.586,6.896,3.905,6.913 c3.319,0.017,0.63-6.69,0.318-8.291c-0.313-1.6-0.387-6.553-0.387-6.553L1120.209,1701.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1124.729,1701.643c-0.052-1.355-0.068-2.485-0.068-2.485l-4.451,2.159 c0,0,0.157,0.846,0.315,1.925C1122.473,1703.648,1123.884,1702.897,1124.729,1701.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1118.582,1689.893c0,0-1.715,0.99-2.342,3.138s0.086,7.688,4.517,9.025 c4.43,1.337,6.35-3.051,5.437-6.481C1125.282,1692.145,1123.297,1687.8,1118.582,1689.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1126.749,1694.245c-0.087,0.921-0.575,1.626-1.09,1.573c-0.516-0.053-0.863-0.843-0.776-1.764 c0.087-0.922,0.575-1.626,1.091-1.573C1126.488,1692.534,1126.835,1693.324,1126.749,1694.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1117.516,1697.796c0.521,0.806,0.519,1.755-0.004,2.122c-0.523,0.366-1.369,0.01-1.889-0.795 c-0.521-0.806-0.519-1.756,0.004-2.122C1116.149,1696.635,1116.995,1696.99,1117.516,1697.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M1123.29,1688.124c0,0-3.913,9.144-6.981,8.733c-3.069-0.411-0.757-5.464-0.757-5.596 c0-0.133,1.868-2.808,2.354-2.808c0.486,0,3.491-0.33,3.491-0.33H1123.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2E35"
    },
    d: "M443.048,1631.644c-9.039-23.571-17.895-47.153-24.321-71.674 c-19.776-75.46-15.002-130.461-14.265-156.906c0.097-3.493-5.496-4.451-5.984-0.846c-1.681,12.413-2.055,25.023-2.137,37.548 c-0.139,21.161,1.145,42.334,3.852,63.481c-14.506,3.786-28.23-1.884-39.457-12.069c-19.353-17.558-26.261-40.958-29.303-66.881 c-0.311-2.648-0.408-5.153-2.56-6.686c-0.478-1.359-2.459-1.776-2.951,0.251c-3.067,3.16-1.581,9.501-1.109,13.582 c6.386,55.208,39.872,81.97,66.833,81.736c2.957-0.026,6.552-0.173,9.766-1.067c1.943,13.205,4.441,26.321,7.499,39.297 c5.824,24.725,13.996,48.584,22.987,72.223c30.744,80.827,40.553,122.118,49.288,145.514c1.321,4.703,8.262,2.733,7.047-2.027 C487.801,1765.422,463.814,1685.79,443.048,1631.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E2E35"
    },
    d: "M566.233,1419.147c-0.291-1.74-1.305-2.894-1.69-4.521c-0.509-2.148-4.007-2.363-4.374,0 c-0.209,1.352-0.958,2.184-1.248,3.568c-0.938,4.469,1.329,29.614-4.588,68.105c-1.573,10.229-3.31,20.402-6.709,30.167 c-5.494,15.783-15.507,32.797-27.957,43.55c-0.396-22.546-1.741-45.063-4.439-67.459c-1.615-13.405-3.652-26.743-6.126-40.004 c-1.205-6.457-2.509-12.895-3.91-19.309c-1.471-6.732-2.856-13.194-6.072-19.286c-0.988-1.87-3.795-1-3.799,1.074 c-0.013,5.978,1.18,11.48,2.423,17.287c1.238,5.781,2.397,11.581,3.477,17.397c8,43.099,11.008,81.371,10.975,124.523 c-13.19-16.628-24.721-36.542-33.266-56.103c-10.27-23.51-17.188-48.811-20.067-74.485c-0.805-7.183-1.295-14.405-1.449-21.635 c-0.08-3.743-0.156-7.485-0.23-11.229c-0.039-1.927-0.775-7.734-4.012-6.032c-2.978,1.565-2.696,5.059-2.945,8.109 c-0.272,3.328-0.295,6.645-0.254,9.984c0.08,6.391,0.421,12.777,1.012,19.14c4.281,46.109,21.641,91.685,48.037,129.03 c4.023,5.692,8.178,11.794,13.064,16.762c-1.125,73.798-12.062,167.02-12.253,174.469c-0.042,1.645,0.328,3.327,0.57,4.952 c0.499,3.351,4.89,2.572,5.787,0c1.696-4.862,1.522-6.757,4.051-33.678c4.51-48.009,9.564-157.989,9.544-162.448 c15.672-11.285,26.77-28.645,34.021-46.775c3.848-9.62,6.106-19.52,7.8-29.767 C567.367,1459.684,567.187,1424.845,566.233,1419.147z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M458.5,1358.92c0.594-5.317,0.903-10.757,0.903-16.29c0-61.714-38.266-111.743-85.47-111.743 c-47.204,0-85.47,50.029-85.47,111.743c0,5.533,0.31,10.973,0.903,16.29H458.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M555.229,1331.457c0.594-7.499,0.903-15.17,0.903-22.974c0-87.033-38.266-157.588-85.47-157.588 c-47.204,0-85.47,70.555-85.47,157.588c0,7.804,0.31,15.475,0.904,22.974H555.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M387.146,1428.024c-0.753-7.499-1.145-15.17-1.145-22.974c0-87.033,48.51-157.588,108.35-157.588 c59.84,0,108.35,70.555,108.35,157.588c0,7.804-0.392,15.475-1.145,22.974H387.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M470.339,1247.463c-29.907,0-56.625,22.383-74.258,57.487c-8.979-3.224-18.52-4.959-28.409-4.959 c-53.098,0-96.143,50.029-96.143,111.743c0,5.533,0.348,10.973,1.016,16.29h292.92c0.669-7.499,1.016-15.17,1.016-22.974 C566.481,1318.018,523.437,1247.463,470.339,1247.463z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M398.511,1731.527c-0.524-3.102-0.796-6.273-0.796-9.5c0-35.987,33.728-65.161,75.333-65.161 c41.605,0,75.333,29.174,75.333,65.161c0,3.227-0.272,6.398-0.796,9.5H398.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M313.254,1715.513c-0.523-4.374-0.796-8.847-0.796-13.396c0-50.752,33.728-91.895,75.333-91.895 c41.605,0,75.333,41.143,75.333,91.895c0,4.55-0.272,9.022-0.796,13.396H313.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M340.837,1771.824c0.523-3.102,0.796-6.273,0.796-9.5c0-35.987-33.728-65.161-75.333-65.161 c-41.605,0-75.333,29.174-75.333,65.161c0,3.227,0.272,6.398,0.796,9.5H340.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M461.401,1771.824c0.664-4.374,1.01-8.847,1.01-13.396c0-50.752-42.757-91.895-95.5-91.895 s-95.499,41.143-95.499,91.895c0,4.55,0.345,9.022,1.009,13.396H461.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M388.076,1666.533c26.36,0,49.909,13.052,65.451,33.521c7.914-1.879,16.323-2.892,25.04-2.892 c46.8,0,84.74,29.174,84.74,65.161c0,3.227-0.307,6.398-0.896,9.5H304.232c-0.589-4.374-0.896-8.847-0.896-13.396 C303.336,1707.676,341.276,1666.533,388.076,1666.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3043.02,
    y: 1627.749,
    style: {
      fill: "#355389"
    },
    width: 7.559,
    height: 132.431
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C8F7C"
    },
    points: "3048.778,1391.64 3011.536,1658.949 3086.021,1658.949  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "3013.899,1641.988 3080.723,1620.922 3079.713,1613.673 3015.002,1634.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "3025.664,1557.541 3069.947,1543.581 3068.938,1536.332 3026.768,1549.626  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2979.026,
    y: 1637.173,
    style: {
      fill: "#355389"
    },
    width: 6.417,
    height: 71.131
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C8F7C"
    },
    points: "2982.234,1499.182 2961.288,1668.465 3003.182,1668.465  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "2968.885,1607.066 2998.754,1632.68 2997.605,1623.398 2969.813,1599.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50BFA5"
    },
    points: "2973.477,1569.961 2991.767,1576.214 2990.906,1569.265 2974.267,1563.576  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2875.186,1731.527c0.523-3.102,0.796-6.273,0.796-9.5c0-35.987-33.728-65.161-75.333-65.161 s-75.333,29.174-75.333,65.161c0,3.227,0.272,6.398,0.797,9.5H2875.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2960.441,1715.513c0.524-4.374,0.797-8.847,0.797-13.396c0-50.752-33.728-91.895-75.333-91.895 s-75.333,41.143-75.333,91.895c0,4.55,0.273,9.022,0.797,13.396H2960.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2932.859,1771.824c-0.523-3.102-0.796-6.273-0.796-9.5c0-35.987,33.728-65.161,75.333-65.161 s75.333,29.174,75.333,65.161c0,3.227-0.272,6.398-0.796,9.5H2932.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2812.295,1771.824c-0.664-4.374-1.01-8.847-1.01-13.396c0-50.752,42.757-91.895,95.5-91.895 c52.742,0,95.499,41.143,95.499,91.895c0,4.55-0.346,9.022-1.01,13.396H2812.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2885.62,1666.533c-26.36,0-49.909,13.052-65.451,33.521c-7.914-1.879-16.323-2.892-25.039-2.892 c-46.801,0-84.74,29.174-84.74,65.161c0,3.227,0.307,6.398,0.896,9.5h258.18c0.588-4.374,0.895-8.847,0.895-13.396 C2970.359,1707.676,2932.421,1666.533,2885.62,1666.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2378.6,1791.698c0,0,0.507,5.542,0.173,7.35c-0.044,0.242-0.143,0.548-0.257,0.886 c-0.344,1.014,0.598,4.107,0.598,4.107l12.629,0.047c0.688,0.002,0.228-0.434-0.332-0.834c-0.916-0.654-1.654-1.086-4.57-2.45 c-0.19-0.089-0.885-0.517-1.135-0.665c-0.634-0.376-1.273-0.973-1.825-1.57c-0.919-0.996-1.06-5.88-1.06-5.88L2378.6,1791.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2385.703,1800.138c-3.328,0.896-5.804,0.346-7.191-0.193c-0.344,1.012-0.99,4.433-0.604,4.433 c3.167,0,5.847,0.6,14.921,0.456c0.325-0.005,0.285-1.121,0.073-1.367C2392.316,1802.785,2385.954,1800.286,2385.703,1800.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2392.893,1782.509c0,0,2.763,4.831,3.209,6.614c0.061,0.238,0.098,0.559,0.134,0.913 c0.107,1.064,2.249,3.488,2.249,3.488l11.508-5.2c0.628-0.283,0.028-0.488-0.646-0.62c-1.105-0.216-1.956-0.302-5.176-0.332 c-0.21-0.002-1.02-0.104-1.309-0.135c-0.732-0.078-1.563-0.354-2.313-0.67c-1.25-0.524-3.404-4.91-3.404-4.91L2392.893,1782.509z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2349.693,1691.045c-1.516-3.072-5.269-4.816-8.689-4.82 c-10.864-0.014-12.246,13.964-19.162,19.354c-2.074,1.617-4.387,2.94-6.362,4.669c-0.031,1.164,0.155,2.314,0.521,3.361 c0.433,1.146,1.004,2.189,1.679,3.152l2.928-1.697l-1.271,3.698c2.609,2.714,6.086,4.715,9.475,6.581 c4.729,2.537,9.762,3.621,14.888,3.855c1.91-3.856,3.257-8.132,4.724-12.116c1.76-4.774,3.233-9.746,3.45-14.845 C2352.036,1698.403,2351.455,1694.615,2349.693,1691.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2402.859,1787.237c-2.656,2.197-5.137,2.724-6.623,2.811c0.107,1.063,0.938,4.442,1.29,4.283 c2.881-1.315,5.568-1.882,13.765-5.778c0.293-0.14-0.206-1.139-0.501-1.275 C2409.975,1786.901,2403.149,1787.269,2402.859,1787.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2369.471,1756.415c-0.787-0.124-2.695-1.491-3.369-1.616c-0.522-0.096-1.651-0.268-2.133-0.339 c-0.59-2.202-3.584-14.204-3.919-17.723c-0.363-3.812-3.059-20.302-3.059-20.302l-6.979,1.269c0,0,2.898,12.686,3.7,18.837 c0.688,5.283,6.484,17.162,7.222,18.415c0.001,0.03,0.001,0.06,0.003,0.092c0.112,1.864,1.011,1.243,1.011,1.243l1.459,0.372 c0,0,5.166,0.497,5.502,0.622C2369.246,1757.409,2370.256,1756.539,2369.471,1756.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M2351.607,1707.712c4.934,1.673,7.037,14.171,7.037,14.171s-7.74,2.161-9.725,1.027 c0,0-2.251-9.979-3.058-9.63L2351.607,1707.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M2346.227,1706.758L2346.227,1706.758L2346.227,1706.758c0.127,0.001,0.311-0.044,0.497-0.103 c0.916-0.164,3.324,0.398,4.884,1.057c1.896,0.8,3.04,7.855,2.865,15.527c-0.07,1.173-0.954,19.238-1.044,19.297 c-2.262,1.455-15.737,2.166-16.675,0.927c-0.938-1.24-1.661-22.656-2.117-23.407l-0.896-13.1 C2335.322,1706.483,2343.8,1706.74,2346.227,1706.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2340.696,1701.934c0,0,0.878,4.545,0.702,6.337c-0.176,1.793,0.67,7.57,4.465,7.589 c3.794,0.02,0.721-7.345,0.363-9.102s-0.442-7.194-0.442-7.194L2340.696,1701.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#F47458"
    },
    d: "M2345.862,1702.292c-0.059-1.487-0.078-2.729-0.078-2.729l-5.088,2.37 c0,0,0.179,0.93,0.36,2.113C2343.283,1704.494,2344.897,1703.67,2345.862,1702.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2338.836,1689.392c0,0-1.961,1.088-2.677,3.445c-0.718,2.357,0.099,8.44,5.163,9.909 c5.065,1.468,7.259-3.35,6.216-7.115C2346.495,1691.864,2344.227,1687.096,2338.836,1689.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2348.172,1694.171c-0.1,1.012-0.657,1.784-1.247,1.727c-0.589-0.058-0.986-0.925-0.887-1.936 c0.099-1.012,0.657-1.785,1.246-1.728C2347.873,1692.293,2348.271,1693.159,2348.172,1694.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2339.431,1689.085c0,0-0.919,6.786-3.112,8.011c-2.194,1.225-1.276,4.234-1.276,4.234 s-1.989-6.99-0.255-9.235S2339.431,1689.085,2339.431,1689.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2337.617,1698.069c0.595,0.884,0.593,1.927-0.005,2.329s-1.564,0.012-2.159-0.873 c-0.596-0.884-0.593-1.927,0.005-2.329C2336.056,1696.795,2337.022,1697.186,2337.617,1698.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2344.996,1698.447l-3.569,0.898c0,0,0.429,1.355,2.011,1.006 C2345.365,1699.927,2344.996,1698.447,2344.996,1698.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2313.034,1756.75c0.059-0.164,0.2-0.172,0.346-0.181c1.411-0.088,2.819-0.195,4.212-0.448 c0.232-0.043,0.461-0.103,0.673-0.195c0.385-0.167,0.77-0.176,1.166-0.079c0.215,0.052,0.432,0.057,0.651,0.049 c0.709-0.025,2.713-0.778,3.747-0.993c0.236-0.049,0.419-0.234,0.471-0.47c0.896-4.08,2.806-13.23,2.997-16.226 c0.243-3.83,2.34-21.13,2.34-21.13l7.117,1.746c0,0-2.505,12.8-3.113,18.987c-0.471,4.778-4.908,15.025-6.309,17.976 c-0.66,2.185-2.292,2.296-2.67,2.354c-0.217,0.033-0.413,0.146-0.55,0.316c-0.248,0.309-0.535,0.578-0.866,0.803 c-0.245,0.165-0.431,0.377-0.589,0.623c-0.286,0.447-0.539,0.913-0.79,1.38c-0.166,0.31-0.348,0.412-0.611,0.349 c-0.281-0.068-0.422-0.271-0.427-0.612c-0.009-0.504,0.138-0.966,0.378-1.403c0.225-0.41,0.199-0.644-0.088-1.006 c-0.166-0.207-0.336-0.409-0.549-0.572c-0.218-0.165-0.443-0.289-0.73-0.239c-0.503,0.143-1.011,0.261-1.529,0.335l-0.424,0.101 c-0.016,0.003-0.231,0.057-0.231,0.057c-0.036,0.011-0.784,0.116-1.041,0.125c-0.206,0.007-0.54,0.03-0.824,0.054 c-0.257,0.021-0.806-0.098-0.824-0.098c-0.251,0.003-0.476-0.081-0.668-0.243c-0.079-0.065-0.154-0.141-0.119-0.259 c0.032-0.108,0.115-0.156,0.224-0.18c0.169-0.036,1.041-0.17,1.03-0.207c-0.261,0.009-1.075,0.015-1.336,0.017 c-0.351,0.001-0.658-0.115-0.908-0.366C2313.089,1757.014,2312.976,1756.916,2313.034,1756.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M2333.932,1706.909c-3.484-0.634-6.635,14.974-6.635,14.974s7.74,2.161,9.724,1.027 c0,0,2.251-9.979,3.058-9.63L2333.932,1706.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B75742"
    },
    d: "M2353.613,1741.251v2.849l26.772,5.63l6.646,19.963l-3.703-2.528l0.855,30.739l-5.632,0.039 c0,0-9.758-25.791-6.557-38.761l-29.632,0.453c0,0-13.43-5.187-6.5-20.823L2353.613,1741.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2353.613,1744.1c0,0,27.773,0.186,29.745,1.705c1.973,1.519,16.773,39.267,16.773,39.267 l-6.455,2.411c0,0-12.843-21.415-13.522-22.943c-0.68-1.527-5.654-12.694-7.553-13.834 C2370.703,1749.566,2353.613,1744.1,2353.613,1744.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2301.809,1732.979c-2.443-0.928-22.958-8.723-23.76-9.318 c-0.725-0.538-11.591-13.585-11.591-13.585l7.485-2.949l9.585,12.313c0.708,0.409,14.065,7.525,14.065,7.525 s2.415,1.371,3.889,2.091c0.41-0.036,0.8-0.075,1.121-0.116c0.699-0.133,1.302-0.351,1.815-0.558 c0.646-0.26,1.999-0.613,2.336-0.611c0.392,0.003,1.198,0.035,1.683,0.062c0.485,0.025,1.056,0.035,1.311,0.08 c0.155,0.027,0.5-0.049,0.745-0.113c0.366-0.095,0.66,0.315,0.452,0.635c-0.196,0.3-0.687,0.443-0.992,0.53 c-0.861,0.245-2.281,0.117-2.239,0.248c0.042,0.13,2.241,1.144,2.485,1.275s2.794,1.324,3.213,1.721 c0.418,0.397,0.244,0.726-0.087,0.735c-0.284,0.01-3.928-1.373-3.928-1.373s-0.465-0.176-0.372,0.076 c0.094,0.251,3.398,1.513,3.857,1.794c0.457,0.281,0.633,0.687,0.158,0.863c-0.577,0.214-4.022-1.353-4.022-1.353 s-0.436-0.189-0.445,0.018s2.82,1.233,3.03,1.453s0.198,0.628-0.268,0.698c-0.548,0.082-3.611-1.343-3.611-1.343 s-0.264-0.042-0.211,0.103c0.053,0.146,2.403,1.194,2.563,1.508c0.135,0.263-0.097,0.39-0.097,0.39 c-0.436,0.378-2.581-0.961-3.743-1.268C2305.082,1734.205,2301.885,1733.007,2301.809,1732.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M2273.846,1701.39c0,0,1.846,0.346,4.975,5.736c2.92,5.031,5.511,10.674,5.511,10.674l-5.242,5.523 c0,0-3.854-11.843-4.182-12.224C2274.579,1710.718,2273.846,1701.39,2273.846,1701.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2291.457,1796.037c0,0-0.282,4.712-0.283,4.722c-0.104,0.599-0.512,2.076-0.512,2.62 c0,2.043,9.605-1.734,7.453-2.64c-0.195-0.082-1.216-0.702-1.279-1.397c-0.1-1.071-0.35-3.239-0.35-3.239L2291.457,1796.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2307.765,1796.037c0,0-0.282,4.712-0.284,4.722c-0.104,0.599-0.512,2.076-0.512,2.62 c0,2.043,9.606-1.734,7.453-2.64c-0.194-0.082-1.648-0.342-1.713-1.037c-0.099-1.071-0.283-4.385-0.283-4.385L2307.765,1796.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2276.564,1746.611l22.963,0.101c0,0,10.372-0.274,12.012,3.348 c1.641,3.623,1.75,46.572,1.75,46.572s-5.427,0.307-5.71,0l-6.844-23.962c-0.667-2.335-0.894-4.775-0.669-7.194l0.596-6.406 l-9.475,0.489c0,0-10.742-0.173-14.283-3.771C2273.363,1752.189,2276.564,1746.611,2276.564,1746.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M2260.999,1744.055l24.69,1.529c0,0,10.625,0.872,12.265,4.494 c1.64,3.623-0.549,46.554-0.549,46.554s-6.245,0.272-6.232,0c0.015-0.325-2.946-17.672-4.357-24.3 c-0.447-2.104-0.604-4.26-0.466-6.407l0.641-6.978c0,0-26.199-0.244-27.338-1.4 C2256.111,1753.948,2260.999,1744.055,2260.999,1744.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF5EB"
    },
    d: "M2273.846,1701.39c-3.578-0.31-9.989,0.499-9.989,0.499s-4.084,0.196-5.309,0.752 c-1.802,0.816-5.308,1.765-3.901,10.113c1.007,5.975,3.26,25.57,4.666,35.611l25.019-2.776 C2279.149,1725.734,2277.233,1701.683,2273.846,1701.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2265.66,1694.111l-2.306,7.821c0,0,3.918,4.511,6.638,4.072c2.281-0.368,1.22-3.663,1.22-3.663 s-0.56-4.435,0.114-6.618C2272.001,1693.539,2265.66,1694.111,2265.66,1694.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2266.593,1696.846c1.039,0.732,2.708,1.633,4.403,2.069c-0.007-1.142,0.067-2.338,0.33-3.191 c0.313-1.008-0.872-1.429-2.236-1.59c-1.802-0.093-3.43-0.022-3.43-0.022l-0.443,1.503 C2265.5,1696.048,2266.247,1696.603,2266.593,1696.846z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2265.121,1681.882c-0.179-0.078-2.064,9.485,0.213,12.294s6.98,3.979,8.817,1.996 c2.031-2.192,2.58-12.564-1.048-15.535C2269.477,1677.666,2265.121,1681.882,2265.121,1681.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2271.979,1675.385c-2.972,0.419-4.985,2.11-5.731,2.838c-1.342,0.074-3.199,0.703-5.264,3.713 c-2.538,3.699-1.104,8.067,1.442,10.327s2.36,4.672,2.36,4.672l0.501-1.223c0.37-0.926,0.561-1.921,0.518-2.92 c-0.025-0.6-0.112-1.251-0.323-1.796c-0.558-1.438,1.527-2.236,2.168-3.361c0.492-0.867,0.641-2.911,1.422-4.346l0.894-1.076 c0,0,1.992-1.373,3.824-0.834S2275.792,1674.849,2271.979,1675.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2267.418,1689.343c-0.054,1.179-0.644,2.108-1.317,2.077c-0.673-0.031-1.176-1.011-1.122-2.188 c0.054-1.179,0.644-2.108,1.316-2.077C2266.969,1687.186,2267.471,1688.165,2267.418,1689.343z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2251.719,1717.8l6.717,2.083c0,0-1.268,5.854-1.283,6.554c0,0,11.44,6.119,16.229,8.039 l-0.13,4.191c-0.938-0.349-1.69-0.709-2.156-0.858c-0.914-0.294-15.549-4.785-15.549-4.785s-5.765-2.054-5.955-3.165 C2249.4,1728.748,2251.719,1717.8,2251.719,1717.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M2249.775,1721.712c0,0,3.222-13.126,4.972-16.493s5.521-3.795,7.969-1.51 c2.447,2.286-4.579,19.788-4.579,19.788L2249.775,1721.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2298.097,1800.304c0,0-2.255,0.625-3.41,0.781s-2.679-1.16-3.495-0.805 c-0.899,0.392-0.864,3.912-0.864,3.912s12.095,1.003,15.495-0.034C2307.17,1803.747,2302.707,1801.759,2298.097,1800.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2314.404,1800.304c0,0-2.256,0.625-3.41,0.781c-1.156,0.156-2.679-1.16-3.496-0.805 c-0.898,0.392-0.863,3.912-0.863,3.912s12.094,1.003,15.495-0.034C2323.477,1803.747,2319.015,1801.759,2314.404,1800.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2270.526,1692.592l3.319,0.02c0,0-0.082,1.296-1.543,1.331 C2270.522,1693.984,2270.526,1692.592,2270.526,1692.592z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2281.837,1727.344c-0.091,0.703,0.234,1.325,0.729,1.39c0.493,0.064,0.968-0.454,1.06-1.157 c0.092-0.704-0.234-1.326-0.729-1.391S2281.929,1726.64,2281.837,1727.344z M2283.291,1726.903 c-0.021,0.162-0.253,0.267-0.518,0.232c-0.266-0.034-0.463-0.194-0.441-0.357c0.021-0.163,0.253-0.268,0.518-0.232 C2283.115,1726.58,2283.313,1726.74,2283.291,1726.903z M2282.01,1727.713c0.033-0.252,0.362-0.416,0.736-0.367 c0.373,0.049,0.65,0.291,0.617,0.543c-0.032,0.251-0.362,0.415-0.736,0.366 C2282.254,1728.207,2281.977,1727.964,2282.01,1727.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F1CA0"
    },
    d: "M2284.553,1729.267c0.134,0.43,0.174,0.882,0.116,1.328l-1.212,9.326 c-0.073,0.563-0.594,0.96-1.163,0.887l-5.333-0.693c-0.569-0.074-0.971-0.591-0.897-1.153l1.212-9.327 c0.058-0.445,0.213-0.874,0.451-1.255L2284.553,1729.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F1CA0"
    },
    d: "M2284.553,1729.267c0.134,0.43,0.174,0.882,0.116,1.328l-1.212,9.326 c-0.073,0.563-0.594,0.96-1.163,0.887l-5.333-0.693c-0.569-0.074-0.971-0.591-0.897-1.153l1.212-9.327 c0.058-0.445,0.213-0.874,0.451-1.255L2284.553,1729.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2277.274,1729.634l-1.212,9.327c-0.073,0.563,0.329,1.08,0.898,1.153l5.332,0.693 c0.57,0.074,1.09-0.323,1.163-0.886l1.212-9.327c0.059-0.445,0.019-0.898-0.115-1.328l-6.825-0.887 C2277.488,1728.761,2277.332,1729.188,2277.274,1729.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M2282.043,1739.737l1.212-9.326c0.058-0.446,0.018-0.899-0.116-1.329l1.414,0.185 c0.134,0.43,0.174,0.882,0.116,1.328l-1.212,9.326c-0.073,0.563-0.594,0.96-1.163,0.887l-1.414-0.185 C2281.449,1740.697,2281.97,1740.301,2282.043,1739.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2277.274,1729.634l-1.212,9.327c-0.073,0.563,0.329,1.08,0.898,1.153l2.18,0.284 c-0.574-0.075-0.981-0.593-0.908-1.156l1.212-9.326c0.058-0.445,0.214-0.873,0.455-1.254l-2.172-0.282 C2277.488,1728.761,2277.332,1729.188,2277.274,1729.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M2277.727,1728.379l6.827,0.888l0,0c0.038-0.299-0.175-0.572-0.476-0.611l-5.735-0.745 C2278.041,1727.871,2277.766,1728.081,2277.727,1728.379L2277.727,1728.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2279.339,
    y: 1734.451,
    transform: "matrix(0.1289 -0.9917 0.9917 0.1289 262.3768 3775.0452)",
    style: {
      fill: "#F7CC7F"
    },
    width: 1.169,
    height: 7.456
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C716C"
    },
    d: "M2273.382,1734.476c0.265-0.171,0.579-0.76,2.607-2.148c0.586-0.401,1.59-0.46,1.59-0.46 s1.235-0.063,1.331,0.229c0.096,0.293-0.109,0.623-0.329,0.725c-0.22,0.101-0.712,0.065-0.932,0.166 c-0.22,0.102-0.508,0.825-0.513,1.108s3.629-0.025,3.629-0.025s1.037-0.14,1.379-0.214c0.291-0.063,1.148-0.322,1.148-0.322 s1.241-0.301,1.309,0.1c0.039,0.236-0.99,0.816-2.068,1.208c-1.16,0.422-2.378,0.65-2.369,0.777 c0.018,0.297,2.016,0.176,2.016,0.176s0.929-0.279,1.357-0.265c0.545-0.27,1.533-0.437,1.582,0.056 c0.009,0.092-1.273,0.717-1.273,0.717s-0.89,0.239-1.307,0.38c-0.737,0.249-1.876,0.268-2.386,0.396 c-0.425,0.106-0.26,0.212-0.28,0.259c-0.016,0.036,0.563-0.018,1.358-0.075c0.4-0.029,0.856,0.026,1.317-0.082 c0.428-0.102,1.032-0.152,1.396-0.174c1.033-0.062,0.884,0.617-0.071,0.836c-0.363,0.083-0.76,0.171-1.162,0.258 c-1.563,0.338-3.048,0.3-3.071,0.475c-0.03,0.227,2.682,0.126,2.682,0.126s1.473,0.376,0.063,0.696 c-1.637,0.372-2.947,0.307-3.005,0.3c-0.392-0.044-1.816,0.23-3.149-0.142c-0.983-0.273-2.383-0.707-3.051-0.916 L2273.382,1734.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2277.045,1731.402l-0.361,2.754c0,0,1.499,0.189,2.205,0.035l0.178-1.364l-0.132-1.125 l-0.491-0.644L2277.045,1731.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M915.587,1721.089l2.885,8.174c0,0-7.154,1.844-7.334,1.905c-0.181,0.062-1.744-8.051-1.744-8.051 L915.587,1721.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M924.359,1788.697c0,0-5.276,6.467-5.311,7.029c-0.035,0.563,0.209,6.704,0.837,7.267 c0.628,0.563,2.471,0.962,1.878,1.595c-0.448,0.479-3.893,0.377-6.177,0.248c-0.667-0.037-1.502-5.475-1.767-6.273 c-0.383-1.161-1.316-3.775-0.967-4.584c0.17-0.395,0.982-1.205,2.128-1.961c1.205-0.795,5.811-7.348,5.811-7.348L924.359,1788.697 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M915.055,1791.979c0,0,3.542,10.197,4.929,10.689c0.368,0.131,2.135,0.462,2.468,1.261 c0.101,0.241,0,1.045,0,1.045h-7.384c0,0-0.934-4.493-1.303-6.467c0,0-1.955-4.823-1.738-5.262 C912.245,1792.808,915.055,1791.979,915.055,1791.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M955.961,1791.803c0,0,4.308,6.201,3.929,8.162c-0.203,1.051-1.107,2.426-0.588,3.414 c0.519,0.988,1.111,1.235,1.111,1.235l13.44,0.222c0.732,0.012,0.248-0.469-0.342-0.912c-0.966-0.725-1.746-1.203-4.833-2.727 c-0.201-0.1-0.934-0.575-1.198-0.74c-0.67-0.417-1.343-1.074-1.923-1.732c-0.965-1.096-5.208-10.027-5.208-10.027 L955.961,1791.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E25A44"
    },
    d: "M940.377,1753.549c0,0-5.335,6.225-6.696,7.211c-1.36,0.985-14.419,25.567-14.419,25.567 l4.652,3.473c0,0,11.671-14.876,17.151-22.833c4.635-6.729,2.928-6.302,5.653-10.397c1.5-2.255,1.16-5.303-0.818-7.132 c-0.246-0.228-0.513-0.466-0.804-0.713c-4.034-3.438-31.685-7.306-31.685-7.306l-17.686,1.771c0,0,14.45,10.359,14.989,10.635 c0.539,0.275,19.955,3.171,20.359,3.171C931.478,1756.995,940.377,1753.549,940.377,1753.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M893.928,1743.349c0,0-3.034,9.304,1.517,13.646c4.551,4.342,31.584,3.859,40.483,3.859 c0,0,3.641,10.199,4.045,11.854c0.405,1.654,18.067,23.019,18.067,23.019l4.854-3.17c0,0-19.011-37.768-20.494-39.422 c-1.483-1.653-22.652-8.27-27.91-9.786C909.231,1741.833,893.928,1743.349,893.928,1743.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M914.12,1713.107c-3.314-10.277-7.021-9.84-7.021-9.84l2.866,21.608 c2.047-0.572,4.711-1.846,6.756-2.437C916.043,1719.19,914.936,1715.639,914.12,1713.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M898.617,1701.423c0,0-6.106-0.398-8.522,2.299c-2.416,2.698,5.359,24.04,5.798,27.474 c0.439,3.434-2.239,12.563-2.239,12.563s14.344,2.958,18.444,0.178c0,0,0.439-24.69,0-27.144 c-0.439-2.453-4.1-12.428-4.979-13.408C906.242,1702.403,898.617,1701.423,898.617,1701.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M935.931,1714.493h-19.636c-0.497,0-1.027,0.412-1.185,0.92l-8.28,26.676 c-0.158,0.508,0.117,0.92,0.614,0.92h19.636c0.497,0,1.027-0.412,1.185-0.92l8.28-26.676 C936.702,1714.905,936.427,1714.493,935.931,1714.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M924.45,1723.055c-0.204,0.795,0.146,1.577,0.78,1.747c0.635,0.17,1.314-0.337,1.518-1.132 c0.204-0.795-0.146-1.576-0.78-1.746C925.333,1721.754,924.654,1722.26,924.45,1723.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M968.377,1800.809c-4.083,1.068-7.102,0.342-8.789-0.353c-0.436,1.259-1.013,2.839-0.707,3.749 c0.375,1.115,0.908,1.367,1.38,1.38c3.729,0.101,13.662,0.236,16.505,0.274c0.397,0.005,0.616-0.469,0.361-0.779 C976.422,1804.221,968.682,1800.998,968.377,1800.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8A492"
    },
    d: "M909.109,1731.917c0.223-0.171,0.458-0.716,2.16-2.1c0.491-0.4,1.382-0.53,1.382-0.53 s1.097-0.151,1.205,0.1c0.108,0.251-0.05,0.559-0.237,0.665c-0.188,0.106-0.63,0.113-0.818,0.22 c-0.188,0.106-0.389,0.768-0.372,1.018c0.018,0.251,3.234-0.305,3.234-0.305s0.914-0.204,1.213-0.296c0.255-0.078,1-0.374,1-0.374 s1.083-0.361,1.174-0.014c0.054,0.205-0.82,0.798-1.751,1.228c-1.003,0.463-2.071,0.759-2.054,0.87 c0.039,0.262,1.811-0.001,1.811-0.001s0.807-0.319,1.191-0.339c0.464-0.28,1.333-0.506,1.415-0.074 c0.015,0.08-1.08,0.731-1.08,0.731s-0.775,0.28-1.136,0.438c-0.638,0.277-1.652,0.383-2.097,0.535 c-0.37,0.127-0.215,0.207-0.23,0.25c-0.011,0.033,0.501-0.06,1.206-0.173c0.355-0.057,0.766-0.042,1.169-0.175 c0.373-0.122,0.909-0.214,1.232-0.262c0.917-0.135,0.836,0.477,0.001,0.744c-0.318,0.102-0.665,0.209-1.017,0.317 c-1.369,0.42-2.695,0.503-2.703,0.659c-0.01,0.202,2.401-0.098,2.401-0.098s1.343,0.217,0.109,0.609 c-1.431,0.456-2.605,0.5-2.657,0.499c-0.352-0.008-1.602,0.345-2.82,0.12c-0.898-0.165-2.18-0.438-2.792-0.571L909.109,1731.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M888.504,1718.879l6.151,1.316c0,0-0.68,5.269-0.639,5.887c0,0,10.674,4.513,15.093,5.835 l0.207,3.712c-0.864-0.234-1.562-0.495-1.989-0.591c-0.838-0.188-14.235-3.015-14.235-3.015s-5.299-1.365-5.555-2.33 C887.281,1728.727,888.504,1718.879,888.504,1718.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M886.628,1724.188c0,0-0.18-14.406,1.164-17.872c1.344-3.466,6.352-5.714,8.965-3.711 c2.612,2.004-1.508,21.583-1.508,21.583H886.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M914.18,1688.676c-0.065-6.838-5.313-12.517-11.961-10.178c-1.495,0.526-3.589,1.731-4.728,2.854 c-3.079,3.031-4.335,7.148-7.486,10.067c0.879,0.91,1.96,1.887,3.273,2.866l1.993-2.035l-0.975,2.762 c3.872,2.643,9.509,5.181,17.546,6.311C913.503,1696.822,914.215,1692.324,914.18,1688.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M900.65,1693.063c0,0-0.032,0.184-0.088,0.497c-0.273,1.505-1.321,6.495-2.029,7.866 c-0.856,1.658,2.931,6.945,6.575,6.301c1.085-0.192-0.917-4.858-0.821-5.353c0.184-0.946,0.434-2.237,0.69-3.561 c0.144-0.747,0.29-1.504,0.427-2.216c0.39-2.021,0.708-3.675,0.708-3.675L900.65,1693.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M900.562,1693.561c0.057-0.314,0.088-0.498,0.088-0.498l5.461-0.14c0,0-0.318,1.653-0.708,3.675 c-0.136,0.708-0.282,1.461-0.425,2.203c-0.843-0.127-1.724-0.547-2.607-1.34c-0.963-0.863-1.594-1.901-1.975-3.009 C900.463,1694.098,900.519,1693.793,900.562,1693.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M906.341,1681.428c0,0-2.505-0.675-4.399,1.207c-1.894,1.883-4.533,8.176-1.064,12.315 c3.468,4.14,7.953,0.687,9.133-3.499C911.191,1687.266,912.143,1682.121,906.341,1681.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M911.193,1691.56c-0.605,0.874-1.474,1.28-1.939,0.907c-0.465-0.374-0.351-1.385,0.255-2.259 c0.606-0.874,1.474-1.279,1.939-0.906C911.913,1689.675,911.799,1690.686,911.193,1691.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M906.725,1680.77c0,0-4.276,5.726-6.752,5.656c-2.476-0.069-3.259,3.191-3.259,3.191 s1.939-7.493,4.556-8.609C903.887,1679.892,906.725,1680.77,906.725,1680.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M900.392,1688.083c0.043,1.135-0.498,2.09-1.207,2.134c-0.71,0.044-1.32-0.84-1.363-1.974 c-0.043-1.135,0.497-2.09,1.207-2.134C899.739,1686.065,900.349,1686.949,900.392,1688.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M905.839,1693.805l-3.095-1.123c0,0-0.346,1.228,1.002,1.762 C905.388,1695.094,905.839,1693.805,905.839,1693.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M930.307,1729.732l0.488,4.066c0.015-0.008,0.041-0.022,0.075-0.043 c0.635-0.375,1.192-0.868,1.649-1.447l3.069-3.891l-0.518-3.357c0,0-2.465-0.969-2.833-0.816 c-0.369,0.152,1.224,1.245,1.224,1.245s-1.27-0.499-1.404-0.191c-0.135,0.308,0.985,1.225,0.985,1.225L930.307,1729.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M933.039,1726.523c0.065,0.165-2.428,7.839-2.428,7.839s-2.104-3.74-2.2-3.919 c-0.096-0.18,2.458-3.404,2.458-3.404L933.039,1726.523z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M1176.386,1724.357c-0.27-0.407,1.818-1.374,1.82-1.862c0.001-0.488-2.876,0.27-3.08-0.103 c-0.375-0.686,3.104-1.024,2.952-1.352c-0.153-0.327-3.755-0.156-3.536-0.85c0.219-0.694,3.746,0.216,3.738-0.212 s-3.36-0.546-3.527-1.442c-0.089-0.479,5.69,0.938,6.213,0.52s-1.254-2.294-0.869-2.752s2.944,3.997,3.308,4.068 c0.362,0.072,8.201,2.109,10.794,2.061c0.089-0.902,1.6-5.326,1.666-6.175c1.613,0.601,2.772-0.14,4.408,0.362 c-0.373,2.858-2.288,10.173-2.919,10.693c-1.92,1.585-12.068-3.092-14.043-3.826c-1.977-0.734-2.838-0.081-4.066-0.146 S1176.656,1724.766,1176.386,1724.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1200.609,1707.439c-2.538,0.86-5.312,8.944-5.411,9.504c-0.631,2.62-0.886,4.748-0.886,4.748l0,0 c-0.057,0.333-0.098,0.593-0.113,0.742c-2.589,0.049-10.331-2.363-10.72-2.441l-0.985,3.556c0.226,0.054,12.94,5.352,14.86,3.767 c0.352-0.29,1.103-2.693,1.763-5.258c1.578,0.021,3.124-0.094,3.894-0.534c0,0,2.185-9.682,2.967-9.343L1200.609,1707.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1203.006,1696.725c0,0-1.759-2.052,0.254-8.437c2.012-6.385,10.545-6.147,13.627-2.355 c3.082,3.793,4.978,10.229,2.607,13.707c-2.37,3.479-5.863,4.388-5.863,4.388L1203.006,1696.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1174.215,1788.265c0,0-0.492,5.377-0.168,7.131c0.043,0.234,0.139,0.531,0.25,0.859 c0.333,0.982-0.581,3.985-0.581,3.985l-12.253,0.045c-0.667,0.002-0.221-0.421,0.322-0.809c0.889-0.636,1.605-1.055,4.435-2.377 c0.185-0.087,0.857-0.503,1.101-0.646c0.615-0.364,1.236-0.943,1.771-1.523c0.892-0.967,1.027-5.705,1.027-5.705 L1174.215,1788.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1160.346,1779.348c0,0-2.68,4.688-3.113,6.418c-0.058,0.231-0.095,0.542-0.129,0.886 c-0.104,1.033-2.182,3.385-2.182,3.385l-11.167-5.045c-0.608-0.275-0.026-0.475,0.629-0.603c1.072-0.209,1.897-0.293,5.021-0.321 c0.204-0.002,0.989-0.101,1.27-0.131c0.711-0.077,1.516-0.345,2.244-0.65c1.213-0.51,3.303-4.765,3.303-4.765L1160.346,1779.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1150.676,1783.936c2.577,2.133,4.984,2.644,6.426,2.727c-0.104,1.031-0.911,4.312-1.252,4.156 c-2.795-1.275-5.402-1.826-13.354-5.606c-0.285-0.136,0.199-1.104,0.486-1.237 C1143.772,1783.61,1150.395,1783.967,1150.676,1783.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00213D"
    },
    d: "M1198.458,1739.317v2.764l-25.977,5.463l-6.448,19.368l3.593-2.452l-0.829,29.824l5.464,0.038 c0,0,9.467-25.023,6.362-37.608l28.75,0.44c0,0,13.03-5.032,6.307-20.204L1198.458,1739.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#223C56"
    },
    d: "M1198.458,1742.081c0,0-26.947,0.181-28.861,1.654c-1.914,1.474-16.274,38.099-16.274,38.099 l6.264,2.34c0,0,12.461-20.778,13.12-22.261c0.66-1.482,5.486-12.317,7.328-13.423 C1181.876,1747.385,1198.458,1742.081,1198.458,1742.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1219.021,1745.37c-1.6-5.156-2.531-13.132-2.531-13.132l0,0c0.682-4.973,1.317-10.16,1.552-10.547 l-0.571-11.723c0,0-0.47-2.423-0.969-2.529c-2.761-0.59-8.883-1.604-10.876-1.589h0c-0.124,0.001-3.838,1.085-5.351,1.724 c-1.839,0.776-2.82,6.824-2.65,14.268c0.051,0.848,0.54,10.795,0.822,15.834c-0.195,1.029-26.891,4.938-28.312,5.827 c-1.421,0.89-1.719,2.163-1.719,2.163c5.572-2.016,14.08,19.971,14.08,19.971s26.926-7.289,30.482-8.355 C1216.532,1756.214,1220.621,1750.525,1219.021,1745.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1208.305,1730.807l-1.257-2.984c-0.349,0.032-2.713,0.092-2.764,0.063 c-0.226-0.126-2.304-1.409-3.14-1.716c-0.268-0.099-1.066-0.22-1.134,0.023c-0.068,0.243,0.035,0.443,0.22,0.516 c0.186,0.072,0.396,0.174,0.582,0.246c0.185,0.072,0.7,0.382,0.714,0.612c0.015,0.23-3.003,0.158-3.003,0.158 s-0.864-0.063-1.149-0.105c-0.243-0.037-0.963-0.206-0.963-0.206s-1.204-0.184-1.244,0.146c-0.049,0.403,3.917,1.199,3.914,1.398 c-0.004,0.243-1.661,0.243-1.661,0.243s-0.779-0.182-1.134-0.148c-0.461-0.192-1.382-0.216-1.404,0.189 c-0.004,0.074,1.178,0.455,1.178,0.455s0.745,0.151,1.096,0.245c0.619,0.167,1.563,0.126,1.989,0.205 c0.355,0.065,0.223,0.16,0.242,0.196c0.014,0.029-0.467,0.015-1.127,0.006c-0.333-0.004-0.708,0.064-1.094-0.002 c-0.357-0.061-0.859-0.072-1.162-0.072c-0.857,0.001-0.708,0.547,0.091,0.678c0.304,0.05,0.636,0.102,0.972,0.152 c1.307,0.198,2.533,0.095,2.56,0.236c0.034,0.183-2.214,0.234-2.214,0.234s-1.205,0.379-0.025,0.571 c1.369,0.222,2.466-0.029,2.514-0.037c0.322-0.056,1.472,0.058,2.561-0.311 C1203.551,1731.431,1208.137,1730.803,1208.305,1730.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M1167.327,1796.046c3.229,0.87,5.631,0.336,6.978-0.187c0.333,0.981,0.96,4.3,0.586,4.3 c-3.073,0-5.673,0.582-14.478,0.443c-0.315-0.005-0.276-1.088-0.071-1.327C1160.911,1798.615,1167.084,1796.19,1167.327,1796.046z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1213.366,1698.235c0,0-0.542,3.536,1.265,8.835c0,0-8.406,6.563-11.371-0.531 c0,0,1.226-2.688,2.182-8.462S1213.366,1698.235,1213.366,1698.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1209.11,1688.317c0,0,2.138,0.402,3.519,2.354c1.381,1.951,2.492,7.802-1.723,10.703 c-4.214,2.901-7.708-0.862-7.9-4.649S1203.444,1687.853,1209.11,1688.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1205.445,1698.87l3.336,0.369c0,0-0.22,1.281-1.691,1.162 C1205.295,1700.257,1205.445,1698.87,1205.445,1698.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1203.183,1693.076c0,0,2.024-3.983,5.242-3.628c3.218,0.355,5.367,4.623,5.367,4.623 s-0.079-5.274-5.011-5.749C1203.851,1687.848,1203.31,1692.607,1203.183,1693.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D9C9"
    },
    d: "M1224.781,1722.985c-0.566-2.301-4.03-15.632-8.28-15.546c0,0-4.236,0.241-2.628,5.975 l5.148,11.423c-2.046,1.269-13.3,2.515-13.363,2.519l0.918,4.059c0,0,16.105,0.151,18.522-3.614 C1225.75,1726.782,1225.469,1724.977,1224.781,1722.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#50BFA5"
    },
    d: "M1198.445,1737.676c0,0,10.264-0.483,15.509,2.094c0,0-7.178-5.021-15.655-4.799 L1198.445,1737.676z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.aa7dd1470d65e1e7364d46c325e9508e.svg";
export { ForwardRef as ReactComponent };